export const AFS_Raw_Export = [
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Jersey Mikes Customers",
    "Actual value": "Jersey_Mikes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Coastal Farm & Ranch Shoppers",
    "Actual value": "Coastal_Farm__and__Ranch"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Intermountain Farmers Association Shoppers",
    "Actual value": "Intermountain_Farmers_Association"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - International Airlines - Air Canada Shoppers",
    "Actual value": "Air_Canada"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - International Airlines - Air France Shoppers",
    "Actual value": "Air_France"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - International Airlines - Avianca Shoppers",
    "Actual value": "Avianca"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - International Airlines - British Airways Shoppers",
    "Actual value": "British_Airways"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - International Airlines - Ryanair Shoppers",
    "Actual value": "Ryanair"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Aquatica Shoppers",
    "Actual value": "Aquatica"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Carowinds Shoppers",
    "Actual value": "Carowinds"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Hersheypark Shoppers",
    "Actual value": "Hersheypark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Legoland Shoppers",
    "Actual value": "Legoland"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Universal Theme Parks Shoppers",
    "Actual value": "Universal_Theme_Parks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Valleyfair Shoppers",
    "Actual value": "Valleyfair"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Arts & Craft Stores - Color Me Mine Shoppers",
    "Actual value": "Color_Me_Mine"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Arts & Craft Stores - Cricut Shoppers",
    "Actual value": "Cricut"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Arts & Craft Stores - Hobby Lobby Shoppers",
    "Actual value": "Hobby_Lobby"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Alltown Shoppers",
    "Actual value": "Alltown"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Family Express Shoppers",
    "Actual value": "Family_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Kwik Fill Shoppers",
    "Actual value": "Kwik_Fill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Lukoil Shoppers",
    "Actual value": "Lukoil"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Motomart Shoppers",
    "Actual value": "Motomart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - On The Run Shoppers",
    "Actual value": "On_The_Run"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Phillips 66 Shoppers",
    "Actual value": "Phillips_66"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Road Ranger Shoppers",
    "Actual value": "Road_Ranger"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Rotten Robbie Shoppers",
    "Actual value": "Rotten_Robbie"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Rutter's Shoppers",
    "Actual value": "Rutters"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Sinclair Shoppers",
    "Actual value": "Sinclair"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Spinx Shoppers",
    "Actual value": "Spinx"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - United Dairy Farmers Shoppers",
    "Actual value": "United_Dairy_Farmers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Auto & Roadside Assistance - Aaa Shoppers",
    "Actual value": "Aaa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Parts Retailers - Carparts.Com Shoppers",
    "Actual value": "CarpartsCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Parts Retailers - Interstate Batteries Shoppers",
    "Actual value": "Interstate_Batteries"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Parts Retailers - Weathertech Shoppers",
    "Actual value": "Weathertech"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - America's Tire Shoppers",
    "Actual value": "Americas_Tire"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - Big O Tires Shoppers",
    "Actual value": "Big_O_Tires"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - Bridgestone / Firestone Shoppers",
    "Actual value": "Bridgestone_/_Firestone"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - Les Schwab Tire Center Shoppers",
    "Actual value": "Les_Schwab_Tire_Center"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - Mavis Discount Tire Shoppers",
    "Actual value": "Mavis_Discount_Tire"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Tire Stores - Tirerack.Com Shoppers",
    "Actual value": "TirerackCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Cost Cutters Shoppers",
    "Actual value": "Cost_Cutters"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Fantastic Sams Shoppers",
    "Actual value": "Fantastic_Sams"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Great Clips Shoppers",
    "Actual value": "Great_Clips"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Hair Cuttery Shoppers",
    "Actual value": "Hair_Cuttery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Saloncentric Shoppers",
    "Actual value": "Saloncentric"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Sport Clips Shoppers",
    "Actual value": "Sport_Clips"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - The Dry Bar Shoppers",
    "Actual value": "The_Dry_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Draftkings.Com Shoppers",
    "Actual value": "DraftkingsCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Espn Bet Shoppers",
    "Actual value": "Espn_Bet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Prizepicks Shoppers",
    "Actual value": "Prizepicks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Cable, Satellite & TV - Cable One Shoppers",
    "Actual value": "Cable_One"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Espn+ Shoppers",
    "Actual value": "Espn+"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Frndly Tv Shoppers",
    "Actual value": "Frndly_Tv"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Cable, Satellite & TV - Mediacom Shoppers",
    "Actual value": "Mediacom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Pandora Internet Radio Shoppers",
    "Actual value": "Pandora_Internet_Radio"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Philo Shoppers",
    "Actual value": "Philo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Roku Shoppers",
    "Actual value": "Roku"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Cable, Satellite & TV - Spectrum Shoppers",
    "Actual value": "Spectrum"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Vix Shoppers",
    "Actual value": "Vix"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Cable, Satellite & TV - Xfinity Shoppers",
    "Actual value": "Xfinity"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Cameras & Photo Equipment - B&H Photo Shoppers",
    "Actual value": "B_and_H_Photo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Cameras & Photo Equipment - Gopro Shoppers",
    "Actual value": "Gopro"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Ghirardelli Chocolates Shoppers",
    "Actual value": "Ghirardelli_Chocolates"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Kilwins Shoppers",
    "Actual value": "Kilwins"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Lindt Shoppers",
    "Actual value": "Lindt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Personal Creations Shoppers",
    "Actual value": "Personal_Creations"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Rocket Fizz Shoppers",
    "Actual value": "Rocket_Fizz"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - See's Candies Shoppers",
    "Actual value": "Sees_Candies"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Acura Shoppers",
    "Actual value": "Acura"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Audi Shoppers",
    "Actual value": "Audi"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Autonation Shoppers",
    "Actual value": "Autonation"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Bmw Shoppers",
    "Actual value": "Bmw"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Buick Shoppers",
    "Actual value": "Buick"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Cadillac Shoppers",
    "Actual value": "Cadillac"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Carmax Shoppers",
    "Actual value": "Carmax"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Chevrolet Shoppers",
    "Actual value": "Chevrolet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Chrysler Shoppers",
    "Actual value": "Chrysler"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Dodge Shoppers",
    "Actual value": "Dodge"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - General Motors Shoppers",
    "Actual value": "General_Motors"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Hyundai Motor Company Shoppers",
    "Actual value": "Hyundai_Motor_Company"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Infiniti Shoppers",
    "Actual value": "Infiniti"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Kia Motors Shoppers",
    "Actual value": "Kia_Motors"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Lexus Shoppers",
    "Actual value": "Lexus"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Mazda Shoppers",
    "Actual value": "Mazda"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Mercedes-Benz Usa Shoppers",
    "Actual value": "Mercedes-Benz_Usa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Nissan Usa Shoppers",
    "Actual value": "Nissan_Usa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Safelite Autoglass Shoppers",
    "Actual value": "Safelite_Autoglass"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Subaru Shoppers",
    "Actual value": "Subaru"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Tesla Shoppers",
    "Actual value": "Tesla"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Toyota Shoppers",
    "Actual value": "Toyota"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Volkswagen Shoppers",
    "Actual value": "Volkswagen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Auto Dealers & Marketplaces - Volvo Shoppers",
    "Actual value": "Volvo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Autobell Car Wash Shoppers",
    "Actual value": "Autobell_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Blue Beacon Truck Wash Shoppers",
    "Actual value": "Blue_Beacon_Truck_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Car Wash Usa Express Shoppers",
    "Actual value": "Car_Wash_Usa_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Cobblestone Auto Spa Shoppers",
    "Actual value": "Cobblestone_Auto_Spa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Dash In Shoppers",
    "Actual value": "Dash_In"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Flagship Carwash Shoppers",
    "Actual value": "Flagship_Carwash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Go Car Wash Shoppers",
    "Actual value": "Go_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Mighty Wash Shoppers",
    "Actual value": "Mighty_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Mister Car Wash Shoppers",
    "Actual value": "Mister_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Soapy Joe's Car Wash Shoppers",
    "Actual value": "Soapy_Joes_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Super Star Car Wash Shoppers",
    "Actual value": "Super_Star_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Tidal Wave Auto Spa Shoppers",
    "Actual value": "Tidal_Wave_Auto_Spa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Tommy's Express Car Wash Shoppers",
    "Actual value": "Tommys_Express_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Ultimate Shine Car Wash Shoppers",
    "Actual value": "Ultimate_Shine_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Whitewater Express Shoppers",
    "Actual value": "Whitewater_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Zips Car Wash Shoppers",
    "Actual value": "Zips_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Advising Services - Stanley Steemer Shoppers",
    "Actual value": "Stanley_Steemer"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - American Association Of Retired Persons Shoppers",
    "Actual value": "American_Association_Of_Retired_Persons"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - American Heart Association Shoppers",
    "Actual value": "American_Heart_Association"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - American Red Cross Shoppers",
    "Actual value": "American_Red_Cross_Shoppers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - Changemob Shoppers",
    "Actual value": "Changemob"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - Habitat For Humanity Shoppers",
    "Actual value": "Habitat_For_Humanity_Shoppers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - Lutheran Services In America Shoppers",
    "Actual value": "Lutheran_Services_In_America"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - Samaritan's Purse Shoppers",
    "Actual value": "Samaritans_Purse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - The Salvation Army Shoppers",
    "Actual value": "The_Salvation_Army"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - World Vision Us Shoppers",
    "Actual value": "World_Vision_Us"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Children's Clothing & Toys - Hanna Andersson Shoppers",
    "Actual value": "Hanna_Andersson"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Children's Clothing & Toys - Janie And Jack Shoppers",
    "Actual value": "Janie_And_Jack"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Chef’Store Shoppers",
    "Actual value": "Chef’Store"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Dropbox Shoppers",
    "Actual value": "Dropbox"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Godaddy Shoppers",
    "Actual value": "Godaddy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Squarespace Shoppers",
    "Actual value": "Squarespace"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Wix Shoppers",
    "Actual value": "Wix"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Namecheap Shoppers",
    "Actual value": "Namecheap"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Chatgpt Shoppers",
    "Actual value": "Chatgpt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Claude Shoppers",
    "Actual value": "Claude"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Facebook Shoppers",
    "Actual value": "Facebook"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Google Shoppers",
    "Actual value": "Google"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Grammarly Shoppers",
    "Actual value": "Grammarly"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Micro Center Shoppers",
    "Actual value": "Micro_Center"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Midjourney Shoppers",
    "Actual value": "Midjourney"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Abc Supply Company Shoppers",
    "Actual value": "Abc_Supply_Company"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Business Services - Bumper.Com Shoppers",
    "Actual value": "BumperCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Armstrong Mccall Shoppers",
    "Actual value": "Armstrong_Mccall"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Aveda Shoppers",
    "Actual value": "Aveda"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Avon Shoppers",
    "Actual value": "Avon"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Bluemercury Shoppers",
    "Actual value": "Bluemercury"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Clinique Shoppers",
    "Actual value": "Clinique"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Cosmo Prof Shoppers",
    "Actual value": "Cosmo_Prof"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Glossier Shoppers",
    "Actual value": "Glossier"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Kiehl's Shoppers",
    "Actual value": "Kiehls"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - L'occitane Shoppers",
    "Actual value": "Loccitane"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Lancome Shoppers",
    "Actual value": "Lancome"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Merle Norman Cosmetic Studio Shoppers",
    "Actual value": "Merle_Norman_Cosmetic_Studio"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Spoiledchild Shoppers",
    "Actual value": "Spoiledchild"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Cosmetics Stores - Thrive Causemetics Shoppers",
    "Actual value": "Thrive_Causemetics"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Shipping & Tracking - Dhl Shoppers",
    "Actual value": "Dhl"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Shipping & Tracking - Postalannex Shoppers",
    "Actual value": "Postalannex"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Dating Services - Bumble Shoppers",
    "Actual value": "Bumble"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Dating Services - Hinge Shoppers",
    "Actual value": "Hinge"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Dating Services - Match.Com Shoppers",
    "Actual value": "MatchCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Avast Shoppers",
    "Actual value": "Avast"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Avg Shoppers",
    "Actual value": "Avg"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Norton Shoppers",
    "Actual value": "Norton"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Snapchat Shoppers",
    "Actual value": "Snapchat"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Tiktok Shoppers",
    "Actual value": "Tiktok"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Blizzard Shoppers",
    "Actual value": "Blizzard"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Chumba Casino Shoppers",
    "Actual value": "Chumba_Casino"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Epic Games Shoppers",
    "Actual value": "Epic_Games"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Fanduel.Com Shoppers",
    "Actual value": "FanduelCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Fliff Shoppers",
    "Actual value": "Fliff"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Nintendo Shoppers",
    "Actual value": "Nintendo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Roblox Shoppers",
    "Actual value": "Roblox"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Sleeper Shoppers",
    "Actual value": "Sleeper"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Stake.Us Shoppers",
    "Actual value": "StakeUs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Steam Shoppers",
    "Actual value": "Steam"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Ubisoft Shoppers",
    "Actual value": "Ubisoft"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Online Gaming - Underdog Fantasy Shoppers",
    "Actual value": "Underdog_Fantasy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Instagram Shoppers",
    "Actual value": "Instagram"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Scribd Shoppers",
    "Actual value": "Scribd"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Aliexpress Shoppers",
    "Actual value": "Aliexpress"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Bargain Hunt Shoppers",
    "Actual value": "Bargain_Hunt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Bi-Mart Shoppers",
    "Actual value": "Bi-Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - dd's Discounts Shoppers",
    "Actual value": "dds_Discounts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Gabe's Shoppers",
    "Actual value": "Gabes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Maxway Shoppers",
    "Actual value": "Maxway"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Popshelf Shoppers",
    "Actual value": "Popshelf"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Roses Shoppers",
    "Actual value": "Roses"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Shoppers World Shoppers",
    "Actual value": "Shoppers_World"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Temu Shoppers",
    "Actual value": "Temu"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Discount Clothing Stores - Variety Wholesalers Shoppers",
    "Actual value": "Variety_Wholesalers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Woodman's Food Market Shoppers",
    "Actual value": "Woodmans_Food_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bad Daddy's Burger Bar Shoppers",
    "Actual value": "Bad_Daddys_Burger_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Board & Brew Shoppers",
    "Actual value": "Board__and__Brew"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Marlow's Tavern Shoppers",
    "Actual value": "Marlows_Tavern"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Tom's Watch Bar Shoppers",
    "Actual value": "Toms_Watch_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Bartell Drugs Shoppers",
    "Actual value": "Bartell_Drugs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Discount Drug Mart Shoppers",
    "Actual value": "Discount_Drug_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Drug Emporium Shoppers",
    "Actual value": "Drug_Emporium"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Duane Reade Shoppers",
    "Actual value": "Duane_Reade"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Hims Shoppers",
    "Actual value": "Hims"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Kinney Drugs Shoppers",
    "Actual value": "Kinney_Drugs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Lewis Drug Shoppers",
    "Actual value": "Lewis_Drug"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Navarro Discount Pharmacy Shoppers",
    "Actual value": "Navarro_Discount_Pharmacy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Nutrafol Shoppers",
    "Actual value": "Nutrafol"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Drug Stores & Pharmacy - Roman Shoppers",
    "Actual value": "Roman"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Wood Ranch Shoppers",
    "Actual value": "Wood_Ranch"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Wolfgang Puck Shoppers",
    "Actual value": "Wolfgang_Puck"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Wings 'N Things Shoppers",
    "Actual value": "Wings_N_Things"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Willy's Mexicana Grill Shoppers",
    "Actual value": "Willys_Mexicana_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Willy Mccoys Shoppers",
    "Actual value": "Willy_Mccoys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Willie's Grill & Icehouse Shoppers",
    "Actual value": "Willies_Grill__and__Icehouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Wildflower Bread Company Shoppers",
    "Actual value": "Wildflower_Bread_Company"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Whiskey Cake Shoppers",
    "Actual value": "Whiskey_Cake"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Western Sizzlin Shoppers",
    "Actual value": "Western_Sizzlin"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Walk-On's Sports Bistreaux Shoppers",
    "Actual value": "Walk-Ons_Sports_Bistreaux"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Wahlburgers Shoppers",
    "Actual value": "Wahlburgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Waffle House Shoppers",
    "Actual value": "Waffle_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Vino Volo Shoppers",
    "Actual value": "Vino_Volo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Village Tavern Shoppers",
    "Actual value": "Village_Tavern"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Village Inn Shoppers",
    "Actual value": "Village_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Velvet Taco Shoppers",
    "Actual value": "Velvet_Taco"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Urbane Cafe Shoppers",
    "Actual value": "Urbane_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Urban Plates Shoppers",
    "Actual value": "Urban_Plates"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Uncle Julio's Mexican Restaurants Shoppers",
    "Actual value": "Uncle_Julios_Mexican_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Twin Peaks Restaurant Shoppers",
    "Actual value": "Twin_Peaks_Restaurant"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Tupelo Honey Cafe Shoppers",
    "Actual value": "Tupelo_Honey_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - True Food Kitchen Shoppers",
    "Actual value": "True_Food_Kitchen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Torchys Tacos Shoppers",
    "Actual value": "Torchys_Tacos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Toppers Pizza Shoppers",
    "Actual value": "Toppers_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Tijuana Flats Shoppers",
    "Actual value": "Tijuana_Flats"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Thirsty Lion Gastro Pub Shoppers",
    "Actual value": "Thirsty_Lion_Gastro_Pub"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - The Old Spaghetti Factory Shoppers",
    "Actual value": "The_Old_Spaghetti_Factory"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - The Halal Guys Shoppers",
    "Actual value": "The_Halal_Guys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - The Flame Broiler Shoppers",
    "Actual value": "The_Flame_Broiler"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Texas De Brazil Shoppers",
    "Actual value": "Texas_De_Brazil"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Teriyaki Madness Shoppers",
    "Actual value": "Teriyaki_Madness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Tender Greens Shoppers",
    "Actual value": "Tender_Greens"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ted's Montana Grill Shoppers",
    "Actual value": "Teds_Montana_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Tazikis Mediterranean Cafe Shoppers",
    "Actual value": "Tazikis_Mediterranean_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Taco Bueno Shoppers",
    "Actual value": "Taco_Bueno"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sweetgreen Shoppers",
    "Actual value": "Sweetgreen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sweet Paris Creperie & Cafe Shoppers",
    "Actual value": "Sweet_Paris_Creperie__and__Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Surcheros Shoppers",
    "Actual value": "Surcheros"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Super Duper Burgers Shoppers",
    "Actual value": "Super_Duper_Burgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sonny's Bbq Shoppers",
    "Actual value": "Sonnys_Bbq"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sodexo Shoppers",
    "Actual value": "Sodexo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Smithfield's Chicken 'N Bar-B-Q Shoppers",
    "Actual value": "Smithfields_Chicken_N_Bar-B-Q"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Slim Chickens Shoppers",
    "Actual value": "Slim_Chickens"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Skyline Chili Shoppers",
    "Actual value": "Skyline_Chili"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sizzler Shoppers",
    "Actual value": "Sizzler"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Silver Diner Shoppers",
    "Actual value": "Silver_Diner"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Showmars Shoppers",
    "Actual value": "Showmars"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Shoney's Shoppers",
    "Actual value": "Shoneys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Shane's Rib Shack Shoppers",
    "Actual value": "Shanes_Rib_Shack"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Seasons 52 Shoppers",
    "Actual value": "Seasons_52"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Saltgrass Steak House Shoppers",
    "Actual value": "Saltgrass_Steak_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Sakura Sushi. Shoppers",
    "Actual value": "Sakura_Sushi"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Rubio's Coastal Grill Shoppers",
    "Actual value": "Rubios_Coastal_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Rock & Brews Shoppers",
    "Actual value": "Rock__and__Brews"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Roberto's Taco Shop Shoppers",
    "Actual value": "Robertos_Taco_Shop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ribcrib Shoppers",
    "Actual value": "Ribcrib"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Razzoo's Cajun Cafe Shoppers",
    "Actual value": "Razzoos_Cajun_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Rainforest Cafe Shoppers",
    "Actual value": "Rainforest_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Primanti Bros. Shoppers",
    "Actual value": "Primanti_Bros"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Postino Shoppers",
    "Actual value": "Postino"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Polly's Pie Shoppers",
    "Actual value": "Pollys_Pie"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pollo Campero Shoppers",
    "Actual value": "Pollo_Campero"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pokeworks Shoppers",
    "Actual value": "Pokeworks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Poke Bros Shoppers",
    "Actual value": "Poke_Bros"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pluckers Wing Bar Shoppers",
    "Actual value": "Pluckers_Wing_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Plaza Azteca Shoppers",
    "Actual value": "Plaza_Azteca"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Playa Bowls Shoppers",
    "Actual value": "Playa_Bowls"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Piada Italian Street Food Shoppers",
    "Actual value": "Piada_Italian_Street_Food"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Peter Piper Pizza Shoppers",
    "Actual value": "Peter_Piper_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Perry's Steakhouse & Grille Shoppers",
    "Actual value": "Perrys_Steakhouse__and__Grille"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Perkins Restaurant & Bakery Shoppers",
    "Actual value": "Perkins_Restaurant__and__Bakery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Penn Station Subs Shoppers",
    "Actual value": "Penn_Station_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pappasito's Cantina Shoppers",
    "Actual value": "Pappasitos_Cantina"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pappas Bbq Shoppers",
    "Actual value": "Pappas_Bbq"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pappadeaux Shoppers",
    "Actual value": "Pappadeaux"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Pancheros Mexican Grill Shoppers",
    "Actual value": "Pancheros_Mexican_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ovg Hospitality Shoppers",
    "Actual value": "Ovg_Hospitality"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Original Pancake House Shoppers",
    "Actual value": "Original_Pancake_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Original Chopshop Shoppers",
    "Actual value": "Original_Chopshop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ono Hawaiian Bbq Shoppers",
    "Actual value": "Ono_Hawaiian_Bbq"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - On The Border Shoppers",
    "Actual value": "On_The_Border"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Olo Shoppers",
    "Actual value": "Olo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Old Chicago Shoppers",
    "Actual value": "Old_Chicago"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - O'Charley's Shoppers",
    "Actual value": "OCharleys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - North Italia Shoppers",
    "Actual value": "North_Italia"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Norms Restaurants Shoppers",
    "Actual value": "Norms_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Nick The Greek Shoppers",
    "Actual value": "Nick_The_Greek"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Newk's Eatery Shoppers",
    "Actual value": "Newks_Eatery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Nathan's Famous Shoppers",
    "Actual value": "Nathans_Famous"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Nando's Peri-Peri Chicken Shoppers",
    "Actual value": "Nandos_Peri-Peri_Chicken"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Naf Naf Grill Shoppers",
    "Actual value": "Naf_Naf_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mountain Mike's Pizza Shoppers",
    "Actual value": "Mountain_Mikes_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Monical's Pizza Shoppers",
    "Actual value": "Monicals_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Moe's Original Bbq Shoppers",
    "Actual value": "Moes_Original_Bbq"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Modern Market Eatery Shoppers",
    "Actual value": "Modern_Market_Eatery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mission Bbq Shoppers",
    "Actual value": "Mission_Bbq"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mimi's Bistro-Bakery Shoppers",
    "Actual value": "Mimis_Bistro-Bakery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Miller's Ale House Shoppers",
    "Actual value": "Millers_Ale_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Miguel's Jr Shoppers",
    "Actual value": "Miguels_Jr"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Miami Grill Shoppers",
    "Actual value": "Miami_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mi Cocina Shoppers",
    "Actual value": "Mi_Cocina"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Metro Diner Shoppers",
    "Actual value": "Metro_Diner"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mendocino Farms Shoppers",
    "Actual value": "Mendocino_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mellow Mushroom Shoppers",
    "Actual value": "Mellow_Mushroom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Medieval Times Dinner & Tournament Shoppers",
    "Actual value": "Medieval_Times_Dinner__and__Tournament"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Me-n-Ed's Pizzeria Shoppers",
    "Actual value": "Me-n-Eds_Pizzeria"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mazzio's Italian Eatery Shoppers",
    "Actual value": "Mazzios_Italian_Eatery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Marie Callender's Shoppers",
    "Actual value": "Marie_Callenders"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Mambo Seafood Shoppers",
    "Actual value": "Mambo_Seafood"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lupe Tortilla Shoppers",
    "Actual value": "Lupe_Tortilla"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lucille's Smokehouse Bar-B-Que Shoppers",
    "Actual value": "Lucilles_Smokehouse_Bar-B-Que"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lou Malnati's Pizzeria Shoppers",
    "Actual value": "Lou_Malnatis_Pizzeria"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lost Pizza Co. Shoppers",
    "Actual value": "Lost_Pizza_Co"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Los Cucos Mexican Cafe Shoppers",
    "Actual value": "Los_Cucos_Mexican_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lone Star Restaurants Shoppers",
    "Actual value": "Lone_Star_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Logan's Roadhouse Shoppers",
    "Actual value": "Logans_Roadhouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Levy Restaurants Shoppers",
    "Actual value": "Levy_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ledo Pizza Shoppers",
    "Actual value": "Ledo_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Le Pain Quotidien Shoppers",
    "Actual value": "Le_Pain_Quotidien"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Lazy Dog Shoppers",
    "Actual value": "Lazy_Dog"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - La Carreta Shoppers",
    "Actual value": "La_Carreta"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - L&L Hawaiian Barbecue Shoppers",
    "Actual value": "L_and_L_Hawaiian_Barbecue"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Kona Grill Shoppers",
    "Actual value": "Kona_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Just Love Coffee Cafe Shoppers",
    "Actual value": "Just_Love_Coffee_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Johnny Rockets Shoppers",
    "Actual value": "Johnny_Rockets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - John's Incredible Pizza Shoppers",
    "Actual value": "Johns_Incredible_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Joe & The Juice Shoppers",
    "Actual value": "Joe__and__The_Juice"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Jinya Ramen Bar Shoppers",
    "Actual value": "Jinya_Ramen_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Jimmy's Egg Shoppers",
    "Actual value": "Jimmys_Egg"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Jaggers Shoppers",
    "Actual value": "Jaggers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Jack's Family Restaurants Shoppers",
    "Actual value": "Jacks_Family_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - J. Alexander's Shoppers",
    "Actual value": "J_Alexanders"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Islands Restaurants Shoppers",
    "Actual value": "Islands_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Iron Hill Brewery Shoppers",
    "Actual value": "Iron_Hill_Brewery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Illegal Pete's Shoppers",
    "Actual value": "Illegal_Petes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Hwy 55 Burgers, Shakes & Fries Shoppers",
    "Actual value": "Hwy_55_Burgers_Shakes__and__Fries"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Hurricane Grill & Wings Shoppers",
    "Actual value": "Hurricane_Grill__and__Wings"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Huhot Mongolian Grill Shoppers",
    "Actual value": "Huhot_Mongolian_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Huddle House Shoppers",
    "Actual value": "Huddle_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Houlihan's Shoppers",
    "Actual value": "Houlihans"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Hopdoddy Burger Bar Shoppers",
    "Actual value": "Hopdoddy_Burger_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Honeygrow Shoppers",
    "Actual value": "Honeygrow"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Hartz Chicken Buffet Shoppers",
    "Actual value": "Hartz_Chicken_Buffet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Hard Rock Shoppers",
    "Actual value": "Hard_Rock"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Groucho's Deli Shoppers",
    "Actual value": "Grouchos_Deli"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Grimaldi's Pizzeria Shoppers",
    "Actual value": "Grimaldis_Pizzeria"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Goodcents Deli Fresh Subs Shoppers",
    "Actual value": "Goodcents_Deli_Fresh_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Good Times Burgers Shoppers",
    "Actual value": "Good_Times_Burgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Golden Krust Caribbean Bakery And Grill Shoppers",
    "Actual value": "Golden_Krust_Caribbean_Bakery_And_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Goldbelly Shoppers",
    "Actual value": "Goldbelly"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Godfather's Pizza Shoppers",
    "Actual value": "Godfathers_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Glory Days Grill Shoppers",
    "Actual value": "Glory_Days_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Gatti's Pizza Shoppers",
    "Actual value": "Gattis_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Gator's Dockside Shoppers",
    "Actual value": "Gators_Dockside"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Friendly's Shoppers",
    "Actual value": "Friendlys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Fox's Pizza Den Shoppers",
    "Actual value": "Foxs_Pizza_Den"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Ford's Garage Shoppers",
    "Actual value": "Fords_Garage"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Flower Child Shoppers",
    "Actual value": "Flower_Child"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - First Watch Shoppers",
    "Actual value": "First_Watch"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Firebirds Wood Fired Grill Shoppers",
    "Actual value": "Firebirds_Wood_Fired_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Farmer Boys Shoppers",
    "Actual value": "Farmer_Boys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Famous Toastery Shoppers",
    "Actual value": "Famous_Toastery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Famous Dave's Shoppers",
    "Actual value": "Famous_Daves"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - El Torito Shoppers",
    "Actual value": "El_Torito"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - El Pollo Regio Shoppers",
    "Actual value": "El_Pollo_Regio"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Einstein Bros. Bagels Shoppers",
    "Actual value": "Einstein_Bros_Bagels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Eat'n Park Shoppers",
    "Actual value": "Eatn_Park"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Earl Of Sandwich Shoppers",
    "Actual value": "Earl_Of_Sandwich"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Duffy's Sports Grill Shoppers",
    "Actual value": "Duffys_Sports_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Doubledave's Pizzaworks Shoppers",
    "Actual value": "Doubledaves_Pizzaworks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Donatos Pizzeria Shoppers",
    "Actual value": "Donatos_Pizzeria"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Dog Haus Shoppers",
    "Actual value": "Dog_Haus"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Dickey*S Barbecue Pit Shoppers",
    "Actual value": "Dickey*S_Barbecue_Pit"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Delaware North Shoppers",
    "Actual value": "Delaware_North"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Culinary Dropout Shoppers",
    "Actual value": "Culinary_Dropout"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Country Kitchen Shoppers",
    "Actual value": "Country_Kitchen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cotton Patch Cafe Shoppers",
    "Actual value": "Cotton_Patch_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Costa Vida Shoppers",
    "Actual value": "Costa_Vida"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cooper's Hawk Winery & Restaurant Shoppers",
    "Actual value": "Coopers_Hawk_Winery__and__Restaurant"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Condado Tacos Shoppers",
    "Actual value": "Condado_Tacos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Colton's Steak House & Grill Shoppers",
    "Actual value": "Coltons_Steak_House__and__Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Clean Eatz Shoppers",
    "Actual value": "Clean_Eatz"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - City Barbeque Shoppers",
    "Actual value": "City_Barbeque"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cicis Pizza Shoppers",
    "Actual value": "Cicis_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Chicken Salad Chick Shoppers",
    "Actual value": "Chicken_Salad_Chick"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Chevys Fresh Mex Shoppers",
    "Actual value": "Chevys_Fresh_Mex"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cheba Hut Shoppers",
    "Actual value": "Cheba_Hut"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Charleys Shoppers",
    "Actual value": "Charleys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cava Grill Shoppers",
    "Actual value": "Cava_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Capriotti's Sandwich Shop Shoppers",
    "Actual value": "Capriottis_Sandwich_Shop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cantina Laredo Shoppers",
    "Actual value": "Cantina_Laredo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cafe Zupas Shoppers",
    "Actual value": "Cafe_Zupas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Cafe Rio Mexican Grill Shoppers",
    "Actual value": "Cafe_Rio_Mexican_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bush's Chicken! Shoppers",
    "Actual value": "Bushs_Chicken!"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Burgerfi Shoppers",
    "Actual value": "Burgerfi"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Buona Shoppers",
    "Actual value": "Buona"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Buca Di Beppo Shoppers",
    "Actual value": "Buca_Di_Beppo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bubbakoo's Burritos Shoppers",
    "Actual value": "Bubbakoos_Burritos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bubba Gump Shrimp Co. Shoppers",
    "Actual value": "Bubba_Gump_Shrimp_Co"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bruegger's Bagels Shoppers",
    "Actual value": "Brueggers_Bagels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Brothers Bar & Grill Shoppers",
    "Actual value": "Brothers_Bar__and__Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Brio Italian Grille Shoppers",
    "Actual value": "Brio_Italian_Grille"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bono's Pit Bar-B-Q Shoppers",
    "Actual value": "Bonos_Pit_Bar-B-Q"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bonefish Grill Shoppers",
    "Actual value": "Bonefish_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bonchon Chicken Shoppers",
    "Actual value": "Bonchon_Chicken"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bolay Fresh Bold Kitchen Shoppers",
    "Actual value": "Bolay_Fresh_Bold_Kitchen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Blaze Pizza Shoppers",
    "Actual value": "Blaze_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Black Bear Diner Shoppers",
    "Actual value": "Black_Bear_Diner"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Black Angus Steakhouse Shoppers",
    "Actual value": "Black_Angus_Steakhouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Biscuitville Shoppers",
    "Actual value": "Biscuitville"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bill Miller Bar-B-Q Shoppers",
    "Actual value": "Bill_Miller_Bar-B-Q"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Big Boy Shoppers",
    "Actual value": "Big_Boy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bibibop Asian Grill Shoppers",
    "Actual value": "Bibibop_Asian_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Benihana Shoppers",
    "Actual value": "Benihana"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Beef 'O' Brady's Shoppers",
    "Actual value": "Beef_O_Bradys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Baumhower's Victory Grille Shoppers",
    "Actual value": "Baumhowers_Victory_Grille"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Barcelona Wine Bar Shoppers",
    "Actual value": "Barcelona_Wine_Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Barberitos Shoppers",
    "Actual value": "Barberitos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bar Louie Shoppers",
    "Actual value": "Bar_Louie"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Bahama Breeze Shoppers",
    "Actual value": "Bahama_Breeze"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Arctic Circle Shoppers",
    "Actual value": "Arctic_Circle"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Aramark Shoppers",
    "Actual value": "Aramark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Applebee's Shoppers",
    "Actual value": "Applebees"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Angry Crab Shack Shoppers",
    "Actual value": "Angry_Crab_Shack"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Andpizza Shoppers",
    "Actual value": "Andpizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - Abuelo's Shoppers",
    "Actual value": "Abuelos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - 99 Restaurants Shoppers",
    "Actual value": "99_Restaurants"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - 54Th Street Grill & Bar Shoppers",
    "Actual value": "54Th_Street_Grill__and__Bar"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Casual Restaurants - 4 Rivers Smokehouse Shoppers",
    "Actual value": "4_Rivers_Smokehouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Blink Shoppers",
    "Actual value": "Blink"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Crutchfield Shoppers",
    "Actual value": "Crutchfield"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Samsung Shoppers",
    "Actual value": "Samsung"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Sony Shoppers",
    "Actual value": "Sony"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Furnishing & Decor Stores - Aaron's Shoppers",
    "Actual value": "Aarons"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Sunbelt Rentals Shoppers",
    "Actual value": "Sunbelt_Rentals"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Advising Services - Orkin Shoppers",
    "Actual value": "Orkin"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Advising Services - Terminix Shoppers",
    "Actual value": "Terminix"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Carhartt Shoppers",
    "Actual value": "Carhartt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Cavender's Shoppers",
    "Actual value": "Cavenders"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Eddie Bauer Shoppers",
    "Actual value": "Eddie_Bauer"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Factory Connection Shoppers",
    "Actual value": "Factory_Connection"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Fashion Nova Shoppers",
    "Actual value": "Fashion_Nova"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - K&G Fashion Superstore Shoppers",
    "Actual value": "K_and_G_Fashion_Superstore"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Kid To Kid Shoppers",
    "Actual value": "Kid_To_Kid"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Lacoste Shoppers",
    "Actual value": "Lacoste"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Lee Shoppers",
    "Actual value": "Lee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Nautica Shoppers",
    "Actual value": "Nautica"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Primark Shoppers",
    "Actual value": "Primark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Quince Shoppers",
    "Actual value": "Quince"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Reef Shoppers",
    "Actual value": "Reef"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Shein Shoppers",
    "Actual value": "Shein"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - The Buckle Shoppers",
    "Actual value": "The_Buckle"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - True Religion Shoppers",
    "Actual value": "True_Religion"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Uniqlo Shoppers",
    "Actual value": "Uniqlo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Vineyard Vines Shoppers",
    "Actual value": "Vineyard_Vines"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Wrangler Shoppers",
    "Actual value": "Wrangler"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Zaxbys Shoppers",
    "Actual value": "Zaxbys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Your Pie Shoppers",
    "Actual value": "Your_Pie"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Yoshinoya Shoppers",
    "Actual value": "Yoshinoya"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Wienerschnitzel Shoppers",
    "Actual value": "Wienerschnitzel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - White Castle Shoppers",
    "Actual value": "White_Castle"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Which Wich Shoppers",
    "Actual value": "Which_Wich"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Whataburger Shoppers",
    "Actual value": "Whataburger"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Wetzel's Pretzels Shoppers",
    "Actual value": "Wetzels_Pretzels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Wayback Burgers Shoppers",
    "Actual value": "Wayback_Burgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Tropical Smoothie Cafe Shoppers",
    "Actual value": "Tropical_Smoothie_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Tokyo Joe's Shoppers",
    "Actual value": "Tokyo_Joes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Togos Shoppers",
    "Actual value": "Togos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Thundercloud Subs Shoppers",
    "Actual value": "Thundercloud_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Tcby Shoppers",
    "Actual value": "Tcby"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Tacotime Nw Shoppers",
    "Actual value": "Tacotime_Nw"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Taco Shop Shoppers",
    "Actual value": "Taco_Shop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Taco Mayo Shoppers",
    "Actual value": "Taco_Mayo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Taco Mama Shoppers",
    "Actual value": "Taco_Mama"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Taco John's Shoppers",
    "Actual value": "Taco_Johns"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Taco Casa Shoppers",
    "Actual value": "Taco_Casa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Sub Station Ii Shoppers",
    "Actual value": "Sub_Station_Ii"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Steak 'n Shake Shoppers",
    "Actual value": "Steak_n_Shake"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Smoothie King Shoppers",
    "Actual value": "Smoothie_King"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Shipley Do-Nuts Shoppers",
    "Actual value": "Shipley_Do-Nuts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Shakey's Pizza Parlor Shoppers",
    "Actual value": "Shakeys_Pizza_Parlor"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Schlotzsky's Shoppers",
    "Actual value": "Schlotzskys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Sbarro Shoppers",
    "Actual value": "Sbarro"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Sarku Japan Shoppers",
    "Actual value": "Sarku_Japan"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Salsaritas Shoppers",
    "Actual value": "Salsaritas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Salata Shoppers",
    "Actual value": "Salata"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Saladworks Shoppers",
    "Actual value": "Saladworks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Salad And Go Shoppers",
    "Actual value": "Salad_And_Go"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Rusty Taco Shoppers",
    "Actual value": "Rusty_Taco"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Runza Shoppers",
    "Actual value": "Runza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Rudy's Country Store & Bar-B-Q Shoppers",
    "Actual value": "Rudys_Country_Store__and__Bar-B-Q"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Roy Rogers Shoppers",
    "Actual value": "Roy_Rogers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Round Table Pizza Shoppers",
    "Actual value": "Round_Table_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Rosati's Pizza Shoppers",
    "Actual value": "Rosatis_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Rosa's Cafe Shoppers",
    "Actual value": "Rosas_Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Rally's Shoppers",
    "Actual value": "Rallys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Raising Cane's Shoppers",
    "Actual value": "Raising_Canes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Primo Hoagies Shoppers",
    "Actual value": "Primo_Hoagies"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Portillo's Shoppers",
    "Actual value": "Portillos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Port Of Subs Shoppers",
    "Actual value": "Port_Of_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Planet Smoothie Shoppers",
    "Actual value": "Planet_Smoothie"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Ranch Shoppers",
    "Actual value": "Pizza_Ranch"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Patron Shoppers",
    "Actual value": "Pizza_Patron"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Inn Shoppers",
    "Actual value": "Pizza_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Guys Shoppers",
    "Actual value": "Pizza_Guys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Factory Shoppers",
    "Actual value": "Pizza_Factory"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pizza Boli's Shoppers",
    "Actual value": "Pizza_Bolis"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Pick Up Stix Shoppers",
    "Actual value": "Pick_Up_Stix"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Philz Coffee Shoppers",
    "Actual value": "Philz_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Orange Julius Shoppers",
    "Actual value": "Orange_Julius"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Mooyah Burgers Shoppers",
    "Actual value": "Mooyah_Burgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Moe's Southwest Grill Shoppers",
    "Actual value": "Moes_Southwest_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Mod Pizza Shoppers",
    "Actual value": "Mod_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Mcalister's Deli Shoppers",
    "Actual value": "Mcalisters_Deli"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Marco's Pizza Shoppers",
    "Actual value": "Marcos_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Marble Slab Creamery Shoppers",
    "Actual value": "Marble_Slab_Creamery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Luby's Shoppers",
    "Actual value": "Lubys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Long John Silver's Shoppers",
    "Actual value": "Long_John_Silvers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Lee's Sandwiches Shoppers",
    "Actual value": "Lees_Sandwiches"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Larry's Giant Subs Shoppers",
    "Actual value": "Larrys_Giant_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - La Colombe Shoppers",
    "Actual value": "La_Colombe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Krystal Shoppers",
    "Actual value": "Krystal"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Kneaders Bakery & Cafe Shoppers",
    "Actual value": "Kneaders_Bakery__and__Cafe"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Just Salad Shoppers",
    "Actual value": "Just_Salad"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Jollibee Shoppers",
    "Actual value": "Jollibee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Jimboy's Tacos Shoppers",
    "Actual value": "Jimboys_Tacos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Jet's Pizza Shoppers",
    "Actual value": "Jets_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Hungry Howie's Pizza Shoppers",
    "Actual value": "Hungry_Howies_Pizza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Great Wraps Shoppers",
    "Actual value": "Great_Wraps"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Golden Chick Shoppers",
    "Actual value": "Golden_Chick"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Fuzzy's Taco Shop Shoppers",
    "Actual value": "Fuzzys_Taco_Shop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Fuddruckers Shoppers",
    "Actual value": "Fuddruckers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Freddy's Frozen Custard & Steakburgers Shoppers",
    "Actual value": "Freddys_Frozen_Custard__and__Steakburgers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Fosters Freeze Shoppers",
    "Actual value": "Fosters_Freeze"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Firehouse Subs Shoppers",
    "Actual value": "Firehouse_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Fatburger Shoppers",
    "Actual value": "Fatburger"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Eegee's Shoppers",
    "Actual value": "Eegees"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Dutch Bros. Coffee Shoppers",
    "Actual value": "Dutch_Bros_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Dunn Brothers Coffee Shoppers",
    "Actual value": "Dunn_Brothers_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Duck Donuts Shoppers",
    "Actual value": "Duck_Donuts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Dippin' Dots Shoppers",
    "Actual value": "Dippin_Dots"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Dion's Shoppers",
    "Actual value": "Dions"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Dave's Hot Chicken Shoppers",
    "Actual value": "Daves_Hot_Chicken"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Culvers Shoppers",
    "Actual value": "Culvers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Cousins Subs Shoppers",
    "Actual value": "Cousins_Subs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Cook Out Shoppers",
    "Actual value": "Cook_Out"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Church's Chicken Shoppers",
    "Actual value": "Churchs_Chicken"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Chopt Shoppers",
    "Actual value": "Chopt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Chicken Express Shoppers",
    "Actual value": "Chicken_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Checkers Shoppers",
    "Actual value": "Checkers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Caribou Coffee Shoppers",
    "Actual value": "Caribou_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Captain D's Shoppers",
    "Actual value": "Captain_Ds"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Caffe Nero Shoppers",
    "Actual value": "Caffe_Nero"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Burgerville Shoppers",
    "Actual value": "Burgerville"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Bruster's Ice Cream Shoppers",
    "Actual value": "Brusters_Ice_Cream"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Braum's Shoppers",
    "Actual value": "Braums"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Blue Bottle Shoppers",
    "Actual value": "Blue_Bottle"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Blake's Lotaburger Shoppers",
    "Actual value": "Blakes_Lotaburger"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Biggby Coffee Shoppers",
    "Actual value": "Biggby_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Baja Fresh Shoppers",
    "Actual value": "Baja_Fresh"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Bad Ass Coffee Of Hawaii Shoppers",
    "Actual value": "Bad_Ass_Coffee_Of_Hawaii"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Avi Foodsystems Inc Shoppers",
    "Actual value": "Avi_Foodsystems_Inc"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Au Bon Pain Shoppers",
    "Actual value": "Au_Bon_Pain"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - American Deli Shoppers",
    "Actual value": "American_Deli"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - A&W Shoppers",
    "Actual value": "A_and_W"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - 7 Brew Drive Thru Coffee Shoppers",
    "Actual value": "7_Brew_Drive_Thru_Coffee"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - 16 Handles Shoppers",
    "Actual value": "16_Handles"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Goods Stores - Ruggable Shoppers",
    "Actual value": "Ruggable"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Online Flower Delivery - Fromyouflowers.Com Shoppers",
    "Actual value": "FromyouflowersCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Delivery Services - Butcherbox Shoppers",
    "Actual value": "Butcherbox"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Go! Calendar's Shoppers",
    "Actual value": "Go!_Calendars"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Oriental Trading Shoppers",
    "Actual value": "Oriental_Trading"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - The Knot Shoppers",
    "Actual value": "The_Knot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Bet365 Shoppers",
    "Actual value": "Bet365"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Betmgm Shoppers",
    "Actual value": "Betmgm"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Caesars Sportsbook Shoppers",
    "Actual value": "Caesars_Sportsbook"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Sports Betting & iGaming - Hard Rock Sportsbook Shoppers",
    "Actual value": "Hard_Rock_Sportsbook"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - 168 Market Shoppers",
    "Actual value": "168_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Adams Fairacre Farms Shoppers",
    "Actual value": "Adams_Fairacre_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Amigos Shoppers",
    "Actual value": "Amigos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Andronico's Community Markets Shoppers",
    "Actual value": "Andronicos_Community_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Angelo Caputo's Fresh Markets Shoppers",
    "Actual value": "Angelo_Caputos_Fresh_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Arlan's Market Shoppers",
    "Actual value": "Arlans_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Baker's Shoppers",
    "Actual value": "Bakers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Barons Market Shoppers",
    "Actual value": "Barons_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Bashas' Shoppers",
    "Actual value": "Bashas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Bel Air Markets Shoppers",
    "Actual value": "Bel_Air_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Big Saver Foods Shoppers",
    "Actual value": "Big_Saver_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Big Y Foods Shoppers",
    "Actual value": "Big_Y_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Bravo Supermarkets Shoppers",
    "Actual value": "Bravo_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Bristol Farms Shoppers",
    "Actual value": "Bristol_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Brookshire Brothers Shoppers",
    "Actual value": "Brookshire_Brothers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Brookshire's Food & Pharmacy Shoppers",
    "Actual value": "Brookshires_Food__and__Pharmacy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Carrs Shoppers",
    "Actual value": "Carrs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Cash Wise Foods Shoppers",
    "Actual value": "Cash_Wise_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Central Market Shoppers",
    "Actual value": "Central_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Chavez Supermarket Shoppers",
    "Actual value": "Chavez_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - City Markets Shoppers",
    "Actual value": "City_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Coborn's Shoppers",
    "Actual value": "Coborns"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Compare Foods Supermarkets Shoppers",
    "Actual value": "Compare_Foods_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Country Market Shoppers",
    "Actual value": "Country_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - County Market Shoppers",
    "Actual value": "County_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Crest Foods Shoppers",
    "Actual value": "Crest_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Ctown Supermarkets Shoppers",
    "Actual value": "Ctown_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Dierbergs Markets Shoppers",
    "Actual value": "Dierbergs_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Dillons Shoppers",
    "Actual value": "Dillons"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Earth Fare Shoppers",
    "Actual value": "Earth_Fare"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - El Rancho Supermercado Shoppers",
    "Actual value": "El_Rancho_Supermercado"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - El Rio Grande Shoppers",
    "Actual value": "El_Rio_Grande"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - El Super Shoppers",
    "Actual value": "El_Super"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Factor Shoppers",
    "Actual value": "Factor"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Family Fare Shoppers",
    "Actual value": "Family_Fare"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Festival Foods Shoppers",
    "Actual value": "Festival_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Fiesta Mart Shoppers",
    "Actual value": "Fiesta_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Fine Fare Shoppers",
    "Actual value": "Fine_Fare"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food Bazaar Supermarket Shoppers",
    "Actual value": "Food_Bazaar_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food City Shoppers",
    "Actual value": "Food_City"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food Depot Shoppers",
    "Actual value": "Food_Depot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food Giant Shoppers",
    "Actual value": "Food_Giant"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food King Shoppers",
    "Actual value": "Food_King"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Food Universe Marketplace Shoppers",
    "Actual value": "Food_Universe_Marketplace"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Foodland Shoppers",
    "Actual value": "Foodland"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Foodmaxx Shoppers",
    "Actual value": "Foodmaxx"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Foodtown Shoppers",
    "Actual value": "Foodtown"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Fresco Y Mas Shoppers",
    "Actual value": "Fresco_Y_Mas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Gelson's Market Shoppers",
    "Actual value": "Gelsons_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Great Wall Supermarket Shoppers",
    "Actual value": "Great_Wall_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Grocery Outlets, Inc Shoppers",
    "Actual value": "Grocery_Outlets_Inc"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Hannaford Shoppers",
    "Actual value": "Hannaford"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Harps Food Store Shoppers",
    "Actual value": "Harps_Food_Store"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Homeland Shoppers",
    "Actual value": "Homeland"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Hungryroot Shoppers",
    "Actual value": "Hungryroot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Jons Marketplace Shoppers",
    "Actual value": "Jons_Marketplace"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Karns Foods Shoppers",
    "Actual value": "Karns_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - King Kullen Shoppers",
    "Actual value": "King_Kullen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Kowalski's Market Shoppers",
    "Actual value": "Kowalskis_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - La Bonita Supermarkets Shoppers",
    "Actual value": "La_Bonita_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - La Michoacana Meat Market Shoppers",
    "Actual value": "La_Michoacana_Meat_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Lidl Shoppers",
    "Actual value": "Lidl"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Lunardi's Markets Shoppers",
    "Actual value": "Lunardis_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Lunds & Byerlys Shoppers",
    "Actual value": "Lunds__and__Byerlys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mac's Fresh Market Shoppers",
    "Actual value": "Macs_Fresh_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Marc's Shoppers",
    "Actual value": "Marcs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Market District Shoppers",
    "Actual value": "Market_District"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Market Of Choice Shoppers",
    "Actual value": "Market_Of_Choice"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mccaffrey's Shoppers",
    "Actual value": "Mccaffreys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Metro Market Shoppers",
    "Actual value": "Metro_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mi Tienda Shoppers",
    "Actual value": "Mi_Tienda"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Misfits Market Shoppers",
    "Actual value": "Misfits_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mitsuwa Marketplace Shoppers",
    "Actual value": "Mitsuwa_Marketplace"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mollie Stones Shoppers",
    "Actual value": "Mollie_Stones"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mother's Market Shoppers",
    "Actual value": "Mothers_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - New Grand Mart Shoppers",
    "Actual value": "New_Grand_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - New Seasons Market Shoppers",
    "Actual value": "New_Seasons_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Nob Hill Foods Shoppers",
    "Actual value": "Nob_Hill_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Northgate Market Shoppers",
    "Actual value": "Northgate_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Nugget Market Shoppers",
    "Actual value": "Nugget_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Patel Brothers Shoppers",
    "Actual value": "Patel_Brothers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Pcc Community Markets Shoppers",
    "Actual value": "Pcc_Community_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Pete's Fresh Market Shoppers",
    "Actual value": "Petes_Fresh_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Presidente Supermarkets Shoppers",
    "Actual value": "Presidente_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Price Less Foods Shoppers",
    "Actual value": "Price_Less_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Price Rite Shoppers",
    "Actual value": "Price_Rite"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Rancho San Miguel Markets Shoppers",
    "Actual value": "Rancho_San_Miguel_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Ray's Food Place Shoppers",
    "Actual value": "Rays_Food_Place"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Reasor's Shoppers",
    "Actual value": "Reasors"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Redner's Warehouse Market Shoppers",
    "Actual value": "Redners_Warehouse_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Restaurant Depot Shoppers",
    "Actual value": "Restaurant_Depot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Ridley's Family Market Shoppers",
    "Actual value": "Ridleys_Family_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Roche Bros. Shoppers",
    "Actual value": "Roche_Bros"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Rosauers Supermarket Shoppers",
    "Actual value": "Rosauers_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Rouses Markets Shoppers",
    "Actual value": "Rouses_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Russ's Market Shoppers",
    "Actual value": "Russs_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Savemart Supermarket Shoppers",
    "Actual value": "Savemart_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Seafood City Supermarket Shoppers",
    "Actual value": "Seafood_City_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Sedano's Shoppers",
    "Actual value": "Sedanos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Sellers Bros Shoppers",
    "Actual value": "Sellers_Bros"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Sendik's Food Market Shoppers",
    "Actual value": "Sendiks_Food_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Shoppers Shoppers",
    "Actual value": "Shoppers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Spring Market Shoppers",
    "Actual value": "Spring_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Stew Leonard's Shoppers",
    "Actual value": "Stew_Leonards"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Stop N Save Shoppers",
    "Actual value": "Stop_N_Save"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Strack & Van Til Shoppers",
    "Actual value": "Strack__and__Van_Til"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Super 1 Foods Shoppers",
    "Actual value": "Super_1_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Super A Foods Shoppers",
    "Actual value": "Super_A_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Super King Markets Shoppers",
    "Actual value": "Super_King_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Super Supermarket Shoppers",
    "Actual value": "Super_Supermarket"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Superior Grocers Shoppers",
    "Actual value": "Superior_Grocers"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Supremo Food Markets Shoppers",
    "Actual value": "Supremo_Food_Markets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - The Fresh Grocer Shoppers",
    "Actual value": "The_Fresh_Grocer"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Three Bears Alaska Shoppers",
    "Actual value": "Three_Bears_Alaska"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Tony's Fresh Market Shoppers",
    "Actual value": "Tonys_Fresh_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Tops Friendly Market Shoppers",
    "Actual value": "Tops_Friendly_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Uncle Giuseppe's Shoppers",
    "Actual value": "Uncle_Giuseppes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Vallarta Supermarkets Shoppers",
    "Actual value": "Vallarta_Supermarkets"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Wayfield Foods Shoppers",
    "Actual value": "Wayfield_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Winco Foods Shoppers",
    "Actual value": "Winco_Foods"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Yoke's Fresh Market Shoppers",
    "Actual value": "Yokes_Fresh_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Aubuchon Hardware Shoppers",
    "Actual value": "Aubuchon_Hardware"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Do It Best Shoppers",
    "Actual value": "Do_It_Best"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Lamps Plus Shoppers",
    "Actual value": "Lamps_Plus"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Mccoy's Building Supply Shoppers",
    "Actual value": "Mccoys_Building_Supply"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Rockler Shoppers",
    "Actual value": "Rockler"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Grainger Shoppers",
    "Actual value": "Grainger"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Johnstone Supply Shoppers",
    "Actual value": "Johnstone_Supply"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Northern Tool Shoppers",
    "Actual value": "Northern_Tool"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Zoro Shoppers",
    "Actual value": "Zoro"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - Amway Shoppers",
    "Actual value": "Amway"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Beauty Salons & Barber Shops - European Wax Center Shoppers",
    "Actual value": "European_Wax_Center"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Fao Schwarz Shoppers",
    "Actual value": "Fao_Schwarz"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Learning Express Shoppers",
    "Actual value": "Learning_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Lego Shoppers",
    "Actual value": "Lego"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Wizards Of The Coast Shoppers",
    "Actual value": "Wizards_Of_The_Coast"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Charitable and Social Services - St Jude Research Hospital Shoppers",
    "Actual value": "St_Jude_Research_Hospital"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Ac Hotels Shoppers",
    "Actual value": "Ac_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Aloft Shoppers",
    "Actual value": "Aloft"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Alterra Mountain Company Shoppers",
    "Actual value": "Alterra_Mountain_Company"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Americinn Shoppers",
    "Actual value": "Americinn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Aria Resort & Casino Shoppers",
    "Actual value": "Aria_Resort__and__Casino"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Autograph Collection Hotels Shoppers",
    "Actual value": "Autograph_Collection_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Baymont Inn & Suites Shoppers",
    "Actual value": "Baymont_Inn__and__Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Bellagio Shoppers",
    "Actual value": "Bellagio"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Caesars Entertainment Shoppers",
    "Actual value": "Caesars_Entertainment"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Cambria Hotel Shoppers",
    "Actual value": "Cambria_Hotel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Candlewood Suites Shoppers",
    "Actual value": "Candlewood_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Circus Circus Shoppers",
    "Actual value": "Circus_Circus"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Clarion Hotel Shoppers",
    "Actual value": "Clarion_Hotel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Comfort Suites Shoppers",
    "Actual value": "Comfort_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Country Inn & Suites By Radisson Shoppers",
    "Actual value": "Country_Inn__and__Suites_By_Radisson"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Crowne Plaza Shoppers",
    "Actual value": "Crowne_Plaza"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Curio Collection Shoppers",
    "Actual value": "Curio_Collection"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Days Inn Shoppers",
    "Actual value": "Days_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Delta Hotels Shoppers",
    "Actual value": "Delta_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Econo Lodge Shoppers",
    "Actual value": "Econo_Lodge"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Extended Stay America Shoppers",
    "Actual value": "Extended_Stay_America"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Fairfield Inn & Suites Shoppers",
    "Actual value": "Fairfield_Inn__and__Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Fairmont Hotel Shoppers",
    "Actual value": "Fairmont_Hotel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Four Points By Sheraton Shoppers",
    "Actual value": "Four_Points_By_Sheraton"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Four Seasons Hotel & Resorts Shoppers",
    "Actual value": "Four_Seasons_Hotel__and__Resorts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Gaylord Hotels Shoppers",
    "Actual value": "Gaylord_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Golden Nugget Shoppers",
    "Actual value": "Golden_Nugget"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Grand Hyatt Shoppers",
    "Actual value": "Grand_Hyatt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Grand Sierra Shoppers",
    "Actual value": "Grand_Sierra"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Great Wolf Shoppers",
    "Actual value": "Great_Wolf"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Harrah's Shoppers",
    "Actual value": "Harrahs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Holiday Inn Club Vacations Shoppers",
    "Actual value": "Holiday_Inn_Club_Vacations"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Holiday Inn Express Shoppers",
    "Actual value": "Holiday_Inn_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Home2 Suites Shoppers",
    "Actual value": "Home2_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Hotel Indigo Shoppers",
    "Actual value": "Hotel_Indigo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Hyatt Shoppers",
    "Actual value": "Hyatt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Hyatt House Shoppers",
    "Actual value": "Hyatt_House"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Hyatt Place Shoppers",
    "Actual value": "Hyatt_Place"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Intercontinental Shoppers",
    "Actual value": "Intercontinental"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Jw Marriott Shoppers",
    "Actual value": "Jw_Marriott"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Kimpton Hotel Shoppers",
    "Actual value": "Kimpton_Hotel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - La Quinta Inn & Suites Shoppers",
    "Actual value": "La_Quinta_Inn__and__Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Luxor Shoppers",
    "Actual value": "Luxor"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Mandalay Bay Shoppers",
    "Actual value": "Mandalay_Bay"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Mgm Resorts Shoppers",
    "Actual value": "Mgm_Resorts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Microtel Inns & Suites Shoppers",
    "Actual value": "Microtel_Inns__and__Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Moxy Hotels Shoppers",
    "Actual value": "Moxy_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Omni Hotels Shoppers",
    "Actual value": "Omni_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Park Mgm Shoppers",
    "Actual value": "Park_Mgm"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Radisson Hotels Shoppers",
    "Actual value": "Radisson_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Ramada Shoppers",
    "Actual value": "Ramada"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Red Roof Inn Shoppers",
    "Actual value": "Red_Roof_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Residence Inn Shoppers",
    "Actual value": "Residence_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Rodeway Inn Shoppers",
    "Actual value": "Rodeway_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Sleep Inn Shoppers",
    "Actual value": "Sleep_Inn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Sonesta Shoppers",
    "Actual value": "Sonesta"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Staybridge Suites Shoppers",
    "Actual value": "Staybridge_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Super 8 Shoppers",
    "Actual value": "Super_8"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - The Cosmopolitan Of Las Vegas Shoppers",
    "Actual value": "The_Cosmopolitan_Of_Las_Vegas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - The Flamingo Shoppers",
    "Actual value": "The_Flamingo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - The Ritz-Carlton Shoppers",
    "Actual value": "The_Ritz-Carlton"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - The Venetian Shoppers",
    "Actual value": "The_Venetian"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Towneplace Suites Shoppers",
    "Actual value": "Towneplace_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Economy Hotels - Travelodge Shoppers",
    "Actual value": "Travelodge"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Treasure Island Hotel And Casino Shoppers",
    "Actual value": "Treasure_Island_Hotel_And_Casino"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Tru By Hilton Shoppers",
    "Actual value": "Tru_By_Hilton"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Vail Resorts Shoppers",
    "Actual value": "Vail_Resorts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Westgate Resorts Shoppers",
    "Actual value": "Westgate_Resorts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Woodspring Suites Shoppers",
    "Actual value": "Woodspring_Suites"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Mid-tier Hotels - Wyndham Hotels Shoppers",
    "Actual value": "Wyndham_Hotels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Luxury Hotels - Wynn And Encore Las Vegas Shoppers",
    "Actual value": "Wynn_And_Encore_Las_Vegas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Goods Stores - Brandsmart Usa Shoppers",
    "Actual value": "Brandsmart_Usa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Goods Stores - Dyson Shoppers",
    "Actual value": "Dyson"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Ancestry Shoppers",
    "Actual value": "Ancestry"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - American Family Insurance Shoppers",
    "Actual value": "American_Family_Insurance"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - American Home Shield Shoppers",
    "Actual value": "American_Home_Shield"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - American Strategic Insurance Shoppers",
    "Actual value": "American_Strategic_Insurance"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Assurant Shoppers",
    "Actual value": "Assurant"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Asurion Shoppers",
    "Actual value": "Asurion"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Blue Cross Blue Shield Shoppers",
    "Actual value": "Blue_Cross_Blue_Shield"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Choice Home Warranty Shoppers",
    "Actual value": "Choice_Home_Warranty"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Direct Auto Insurance Shoppers",
    "Actual value": "Direct_Auto_Insurance"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - First American Shoppers",
    "Actual value": "First_American"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Optum Shoppers",
    "Actual value": "Optum"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - The General Shoppers",
    "Actual value": "The_General"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - The Hartford Shoppers",
    "Actual value": "The_Hartford"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Unitedhealth Group Shoppers",
    "Actual value": "Unitedhealth_Group"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Insurance Providers - Usaa Shoppers",
    "Actual value": "Usaa"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Jewelry Stores - Banter By Piercing Pagoda Shoppers",
    "Actual value": "Banter_By_Piercing_Pagoda"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Jewelry Stores - Icing Shoppers",
    "Actual value": "Icing"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Jewelry Stores - Mary Kay Shoppers",
    "Actual value": "Mary_Kay"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Advising Services - Trugreen Shoppers",
    "Actual value": "Trugreen"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Advising Services - Tide Dry Cleaners Shoppers",
    "Actual value": "Tide_Dry_Cleaners"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Business Services - Legalzoom.Com Shoppers",
    "Actual value": "LegalzoomCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Fashion Accessories - Beis Travel Shoppers",
    "Actual value": "Beis_Travel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Marine & Boating Stores - West Marine Shoppers",
    "Actual value": "West_Marine"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Quest Diagnostics Shoppers",
    "Actual value": "Quest_Diagnostics"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Aspen Dental Shoppers",
    "Actual value": "Aspen_Dental"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Banner Urgent Care Shoppers",
    "Actual value": "Banner_Urgent_Care"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Callondoc Shoppers",
    "Actual value": "Callondoc"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Care Now Shoppers",
    "Actual value": "Care_Now"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Curology Shoppers",
    "Actual value": "Curology"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Gohealth Urgent Care Shoppers",
    "Actual value": "Gohealth_Urgent_Care"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Hand & Stone Shoppers",
    "Actual value": "Hand__and__Stone"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Kaiser Permanente Shoppers",
    "Actual value": "Kaiser_Permanente"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Kelsey Seybold Shoppers",
    "Actual value": "Kelsey_Seybold"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Nextcare Shoppers",
    "Actual value": "Nextcare"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Patient First Shoppers",
    "Actual value": "Patient_First"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Planned Parenthood Shoppers",
    "Actual value": "Planned_Parenthood"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Medical Services - Seed Shoppers",
    "Actual value": "Seed"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Anytime Fitness Shoppers",
    "Actual value": "Anytime_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Chuze Fitness Shoppers",
    "Actual value": "Chuze_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Classpass Shoppers",
    "Actual value": "Classpass"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Club Pilates Shoppers",
    "Actual value": "Club_Pilates"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Crunch Fitness Shoppers",
    "Actual value": "Crunch_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Eos Fitness Shoppers",
    "Actual value": "Eos_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Life Time Fitness Shoppers",
    "Actual value": "Life_Time_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Health & Fitness - Orangetheory Fitness Shoppers",
    "Actual value": "Orangetheory_Fitness"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Business Services - Flexjobs Shoppers",
    "Actual value": "Flexjobs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Alo Yoga Shoppers",
    "Actual value": "Alo_Yoga"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Asos Shoppers",
    "Actual value": "Asos"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Cotton On Shoppers",
    "Actual value": "Cotton_On"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Crossroads Trading Co. Shoppers",
    "Actual value": "Crossroads_Trading_Co"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Custom Ink Shoppers",
    "Actual value": "Custom_Ink"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Discovery Clothing Shoppers",
    "Actual value": "Discovery_Clothing"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Garage Clothing Shoppers",
    "Actual value": "Garage_Clothing"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Melrose Shoppers",
    "Actual value": "Melrose"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Rue21 Shoppers",
    "Actual value": "Rue21"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Tecovas Shoppers",
    "Actual value": "Tecovas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - The Realreal Shoppers",
    "Actual value": "The_Realreal"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Tommy Bahama Shoppers",
    "Actual value": "Tommy_Bahama"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Vuori Shoppers",
    "Actual value": "Vuori"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Wss Shoppers",
    "Actual value": "Wss"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Scrubs & Beyond Shoppers",
    "Actual value": "Scrubs__and__Beyond"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Clothing & Fashion Retailers - Uniform Advantage Shoppers",
    "Actual value": "Uniform_Advantage"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Computers & Electronics - Batteries Plus Bulbs Shoppers",
    "Actual value": "Batteries_Plus_Bulbs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Blain's Farm & Fleet Shoppers",
    "Actual value": "Blains_Farm__and__Fleet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Bomgaars Shoppers",
    "Actual value": "Bomgaars"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Buc-ee's Shoppers",
    "Actual value": "Buc-ees"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Depop Shoppers",
    "Actual value": "Depop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Mercari Shoppers",
    "Actual value": "Mercari"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Murdoch's Ranch & Home Supply Shoppers",
    "Actual value": "Murdochs_Ranch__and__Home_Supply"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Pga Tour Superstore Shoppers",
    "Actual value": "Pga_Tour_Superstore"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Poshmark Shoppers",
    "Actual value": "Poshmark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Mass Retailers - Online & Mobile Retailers - Redbubble Shoppers",
    "Actual value": "Redbubble"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Spirit Halloween Shoppers",
    "Actual value": "Spirit_Halloween"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Farm & Ranch Supply - Family Farm & Home Shoppers",
    "Actual value": "Family_Farm__and__Home"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - 99 Ranch Market Shoppers",
    "Actual value": "99_Ranch_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Ag1 By Athletic Greens Shoppers",
    "Actual value": "Ag1_By_Athletic_Greens"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Beans & Brews Shoppers",
    "Actual value": "Beans__and__Brews"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Beef Jerky Outlet Shoppers",
    "Actual value": "Beef_Jerky_Outlet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Bluestone Lane Shoppers",
    "Actual value": "Bluestone_Lane"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Cardenas Market Shoppers",
    "Actual value": "Cardenas_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Cefco Shoppers",
    "Actual value": "Cefco"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Coca Cola Shoppers",
    "Actual value": "Coca_Cola"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Crumbl Cookies Shoppers",
    "Actual value": "Crumbl_Cookies"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Cumberland Farms Shoppers",
    "Actual value": "Cumberland_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Fresh Thyme Farmers Market Shoppers",
    "Actual value": "Fresh_Thyme_Farmers_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Getgo Cafe + Market Shoppers",
    "Actual value": "Getgo_Cafe_+_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Gong Cha Shoppers",
    "Actual value": "Gong_Cha"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Great American Cookies Shoppers",
    "Actual value": "Great_American_Cookies"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - H Mart Shoppers",
    "Actual value": "H_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Harmons Grocery Shoppers",
    "Actual value": "Harmons_Grocery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Hickory Farms Shoppers",
    "Actual value": "Hickory_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Honey Baked Ham Shoppers",
    "Actual value": "Honey_Baked_Ham"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Huck's Shoppers",
    "Actual value": "Hucks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Hudson Shoppers",
    "Actual value": "Hudson"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Iherb Shoppers",
    "Actual value": "Iherb"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Insomnia Cookies Shoppers",
    "Actual value": "Insomnia_Cookies"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Keurig Shoppers",
    "Actual value": "Keurig"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mighty Leaf Shoppers",
    "Actual value": "Mighty_Leaf"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Minit Mart Shoppers",
    "Actual value": "Minit_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Mom's Organic Market Shoppers",
    "Actual value": "Moms_Organic_Market"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Nekter Shoppers",
    "Actual value": "Nekter"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Oats Overnight Shoppers",
    "Actual value": "Oats_Overnight"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Omaha Steaks Shoppers",
    "Actual value": "Omaha_Steaks"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Oncue Express Shoppers",
    "Actual value": "Oncue_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Restaurant and Dining - Fast Food & QSR - Paris Baguette Shoppers",
    "Actual value": "Paris_Baguette"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Pepsico Shoppers",
    "Actual value": "Pepsico"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Philly Pretzel Factory Shoppers",
    "Actual value": "Philly_Pretzel_Factory"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Pretzelmaker Shoppers",
    "Actual value": "Pretzelmaker"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Pump & Pantry Shoppers",
    "Actual value": "Pump__and__Pantry"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Car Washes - Quick Quack Car Wash Shoppers",
    "Actual value": "Quick_Quack_Car_Wash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Quickchek Shoppers",
    "Actual value": "Quickchek"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Rita's Shoppers",
    "Actual value": "Ritas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Grocery Stores - Ryze Shoppers",
    "Actual value": "Ryze"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Convenience Stores - Stripes Shoppers",
    "Actual value": "Stripes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Altar'd State Shoppers",
    "Actual value": "Altard_State"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Grove Collaborative Shoppers",
    "Actual value": "Grove_Collaborative"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Kendra Scott Shoppers",
    "Actual value": "Kendra_Scott"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Navy Exchange Shoppers",
    "Actual value": "Navy_Exchange"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Woot Shoppers",
    "Actual value": "Woot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Nbc Universal Shoppers",
    "Actual value": "Nbc_Universal"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Streaming Music & Video - Starz Inc Shoppers",
    "Actual value": "Starz_Inc"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Alamo Drafthouse Cinema Shoppers",
    "Actual value": "Alamo_Drafthouse_Cinema"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - B&B Theaters Shoppers",
    "Actual value": "B_and_B_Theaters"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Harkins Shoppers",
    "Actual value": "Harkins"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Look Dine-In Cinemas Shoppers",
    "Actual value": "Look_Dine-In_Cinemas"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Marcus Theaters Shoppers",
    "Actual value": "Marcus_Theaters"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Ncg Cinema Shoppers",
    "Actual value": "Ncg_Cinema"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Movies & Films - Studio Movie Grill Shoppers",
    "Actual value": "Studio_Movie_Grill"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Music & Instrument Stores - Guitar Center Shoppers",
    "Actual value": "Guitar_Center"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Music & Instrument Stores - Premiumbeat Shoppers",
    "Actual value": "Premiumbeat"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Music & Instrument Stores - Sweetwater Shoppers",
    "Actual value": "Sweetwater"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Coinbase Shoppers",
    "Actual value": "Coinbase"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Crypto.Com Shoppers",
    "Actual value": "CryptoCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Remitly Shoppers",
    "Actual value": "Remitly"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Speedycash Shoppers",
    "Actual value": "Speedycash"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - 1-800 Contacts Shoppers",
    "Actual value": "1-800_Contacts"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - America's Best Contacts & Eyeglasses Shoppers",
    "Actual value": "Americas_Best_Contacts__and__Eyeglasses"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Eyebuydirect Shoppers",
    "Actual value": "Eyebuydirect"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Eyemart Express Shoppers",
    "Actual value": "Eyemart_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Glassesusa.Com Shoppers",
    "Actual value": "GlassesusaCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Myeyedr. Shoppers",
    "Actual value": "Myeyedr"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Shopko Optical Shoppers",
    "Actual value": "Shopko_Optical"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Eyewear & Sunglasses - Zenni Optical Shoppers",
    "Actual value": "Zenni_Optical"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Abc Fine Wine Shoppers",
    "Actual value": "Abc_Fine_Wine"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Bevmo! Shoppers",
    "Actual value": "Bevmo!"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Binny's Beverage Depot Shoppers",
    "Actual value": "Binnys_Beverage_Depot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Goody Goody Liquor Shoppers",
    "Actual value": "Goody_Goody_Liquor"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Mgm Liquor Warehouse Shoppers",
    "Actual value": "Mgm_Liquor_Warehouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Pennsylvania Liquor Control Board Shoppers",
    "Actual value": "Pennsylvania_Liquor_Control_Board"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Spec's Shoppers",
    "Actual value": "Specs"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Total Wine & More Shoppers",
    "Actual value": "Total_Wine__and__More"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Twin Liquors Shoppers",
    "Actual value": "Twin_Liquors"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Food & Pharmacy - Beer, Wine & Liquor Stores - Wb Liquors Shoppers",
    "Actual value": "Wb_Liquors"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Parking & Garages - Diamond Parking Shoppers",
    "Actual value": "Diamond_Parking"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Parking & Garages - Parkwhiz Shoppers",
    "Actual value": "Parkwhiz"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Parking & Garages - The Parking Spot Shoppers",
    "Actual value": "The_Parking_Spot"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Passenger Rail - Amtrak Shoppers",
    "Actual value": "Amtrak"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Passenger Rail - Brightline Shoppers",
    "Actual value": "Brightline"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Chuck & Don's Pet Food Outlet Shoppers",
    "Actual value": "Chuck__and__Dons_Pet_Food_Outlet"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Hollywood Feed Shoppers",
    "Actual value": "Hollywood_Feed"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Mud Bay Shoppers",
    "Actual value": "Mud_Bay"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Pet Food Express Shoppers",
    "Actual value": "Pet_Food_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Petlab Co. Shoppers",
    "Actual value": "Petlab_Co"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - The Farmer's Dog Shoppers",
    "Actual value": "The_Farmers_Dog"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Unleashed Shoppers",
    "Actual value": "Unleashed"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Wild Birds Unlimited Shoppers",
    "Actual value": "Wild_Birds_Unlimited"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Pet Owners - Woof Gang Bakery Shoppers",
    "Actual value": "Woof_Gang_Bakery"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Cenex Shoppers",
    "Actual value": "Cenex"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Ferrellgas Partners Shoppers",
    "Actual value": "Ferrellgas_Partners"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Suburban Propane Partners Shoppers",
    "Actual value": "Suburban_Propane_Partners"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Home - Home Improvement Stores - Ferguson Shoppers",
    "Actual value": "Ferguson"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Jewelry Stores - Swarovski Shoppers",
    "Actual value": "Swarovski"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Payments & Digital Wallets - Apple Pay Shoppers",
    "Actual value": "Apple_Pay"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Beenverified.Com Shoppers",
    "Actual value": "BeenverifiedCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Canva Shoppers",
    "Actual value": "Canva"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - EV Charging Networks - Chargepoint Shoppers",
    "Actual value": "Chargepoint"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - EV Charging Networks - Electrify America Shoppers",
    "Actual value": "Electrify_America"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - EV Charging Networks - Evgo Shoppers",
    "Actual value": "Evgo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Justanswer Shoppers",
    "Actual value": "Justanswer"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Payments & Digital Wallets - Paypal Shoppers",
    "Actual value": "Paypal"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Payments & Digital Wallets - Samsung Pay Shoppers",
    "Actual value": "Samsung_Pay"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Software Services - Xsolla Shoppers",
    "Actual value": "Xsolla"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Record Stores - Fye Shoppers",
    "Actual value": "Fye"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Defy Shoppers",
    "Actual value": "Defy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Main Event Entertainment Shoppers",
    "Actual value": "Main_Event_Entertainment"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Puttshack Shoppers",
    "Actual value": "Puttshack"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Recreation.Gov Shoppers",
    "Actual value": "RecreationGov"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Rockin' Jump Shoppers",
    "Actual value": "Rockin_Jump"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Sky Zone Shoppers",
    "Actual value": "Sky_Zone"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Amusement Parks - Urban Air Shoppers",
    "Actual value": "Urban_Air"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Gifts & Party Retailers - Mardel Shoppers",
    "Actual value": "Mardel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Educational Services - Abcmouse Shoppers",
    "Actual value": "Abcmouse"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Educational Services - Aceable Shoppers",
    "Actual value": "Aceable"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Educational Services - Babbel Shoppers",
    "Actual value": "Babbel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Educational Services - Udemy Shoppers",
    "Actual value": "Udemy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Allsup's Shoppers",
    "Actual value": "Allsups"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Arco Shoppers",
    "Actual value": "Arco"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Clark Shoppers",
    "Actual value": "Clark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Country Fair Shoppers",
    "Actual value": "Country_Fair"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Crown Shoppers",
    "Actual value": "Crown"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Fas Mart Shoppers",
    "Actual value": "Fas_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Fastrac Shoppers",
    "Actual value": "Fastrac"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Fastrip Shoppers",
    "Actual value": "Fastrip"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Five Star Food Mart Shoppers",
    "Actual value": "Five_Star_Food_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Holiday Stationstores Shoppers",
    "Actual value": "Holiday_Stationstores"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Irving Oil Shoppers",
    "Actual value": "Irving_Oil"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Kum & Go Shoppers",
    "Actual value": "Kum__and__Go"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Kwik Mart Shoppers",
    "Actual value": "Kwik_Mart"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Love's Travel & Country Stores Shoppers",
    "Actual value": "Loves_Travel__and__Country_Stores"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Mapco Express Shoppers",
    "Actual value": "Mapco_Express"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Maverik Adventure's First Stop Shoppers",
    "Actual value": "Maverik_Adventures_First_Stop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Pilot Flying J Shoppers",
    "Actual value": "Pilot_Flying_J"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Racetrac Shoppers",
    "Actual value": "Racetrac"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Raceway Shoppers",
    "Actual value": "Raceway"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Royal Farms Shoppers",
    "Actual value": "Royal_Farms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Speedway Shoppers",
    "Actual value": "Speedway"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Sprint Food Stores Shoppers",
    "Actual value": "Sprint_Food_Stores"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Stewart's Shop Shoppers",
    "Actual value": "Stewarts_Shop"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Stop N Go Shoppers",
    "Actual value": "Stop_N_Go"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Thorntons Shoppers",
    "Actual value": "Thorntons"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Town & Country Shoppers",
    "Actual value": "Town__and__Country"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Travelcenters Of America Shoppers",
    "Actual value": "Travelcenters_Of_America"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Weigel's Shoppers",
    "Actual value": "Weigels"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Automotive - Gas & Service Stations - Wesco Shoppers",
    "Actual value": "Wesco"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Aldo Shoppers",
    "Actual value": "Aldo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Ariat International Shoppers",
    "Actual value": "Ariat_International"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Asics Shoppers",
    "Actual value": "Asics"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Birkenstock Shoppers",
    "Actual value": "Birkenstock"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Bootbarn Shoppers",
    "Actual value": "Bootbarn"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Brown Shoppers",
    "Actual value": "Brown"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Cole Haan Shoppers",
    "Actual value": "Cole_Haan"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Fleet Feet Sports Shoppers",
    "Actual value": "Fleet_Feet_Sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Goat Shoppers",
    "Actual value": "Goat"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Hey Dude Shoppers",
    "Actual value": "Hey_Dude"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Hoka Shoppers",
    "Actual value": "Hoka"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Johnston & Murphy Shoppers",
    "Actual value": "Johnston__and__Murphy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - New Balance Shoppers",
    "Actual value": "New_Balance"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Off Broadway Shoppers",
    "Actual value": "Off_Broadway"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Rack Room Shoes Shoppers",
    "Actual value": "Rack_Room_Shoes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Red Wing Shoes Shoppers",
    "Actual value": "Red_Wing_Shoes"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Rothy's Shoppers",
    "Actual value": "Rothys"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Shoe Sensation Shoppers",
    "Actual value": "Shoe_Sensation"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Shoe Show Shoppers",
    "Actual value": "Shoe_Show"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Shoe Station Shoppers",
    "Actual value": "Shoe_Station"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Stockx Shoppers",
    "Actual value": "Stockx"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Footwear Retailers - Toms Shoppers",
    "Actual value": "Toms"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Backcountry Shoppers",
    "Actual value": "Backcountry"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Brooks Sports Shoppers",
    "Actual value": "Brooks_Sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - City Gear Shoppers",
    "Actual value": "City_Gear"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Dunham's sports Shoppers",
    "Actual value": "Dunhams_sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Going Going Gone Shoppers",
    "Actual value": "Going_Going_Gone"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - On Shoppers",
    "Actual value": "On"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Orvis Shoppers",
    "Actual value": "Orvis"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Peloton Shoppers",
    "Actual value": "Peloton"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Play It Again Sports Shoppers",
    "Actual value": "Play_It_Again_Sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Pure Hockey Shoppers",
    "Actual value": "Pure_Hockey"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Shoe Palace Shoppers",
    "Actual value": "Shoe_Palace"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Soccer.Com Shoppers",
    "Actual value": "SoccerCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Specialty Retail - Sporting Goods & Outdoors - Yeti Shoppers",
    "Actual value": "Yeti"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Columbia Shoppers",
    "Actual value": "Columbia"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Gymshark Shoppers",
    "Actual value": "Gymshark"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Jd Sports Shoppers",
    "Actual value": "Jd_Sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Kuiu Shoppers",
    "Actual value": "Kuiu"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Mlb Shoppers",
    "Actual value": "Mlb"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Nba Shoppers",
    "Actual value": "Nba"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Nfl Shoppers",
    "Actual value": "Nfl"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Apparel & Accessories - Activewear - Road Runner Sports Shoppers",
    "Actual value": "Road_Runner_Sports"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Office Supply Stores - Paper Source Shoppers",
    "Actual value": "Paper_Source"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Office, Electronics, Games - Office Supply Stores - Uline Shoppers",
    "Actual value": "Uline"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Cruise Lines - Msc Cruises Shoppers",
    "Actual value": "Msc_Cruises"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Cellular Sales Shoppers",
    "Actual value": "Cellular_Sales"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - C Spire Shoppers",
    "Actual value": "C_Spire"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Consumer Cellular Shoppers",
    "Actual value": "Consumer_Cellular"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Earthlink Shoppers",
    "Actual value": "Earthlink"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Idt Shoppers",
    "Actual value": "Idt"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Mint Mobile Shoppers",
    "Actual value": "Mint_Mobile"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Puretalk Shoppers",
    "Actual value": "Puretalk"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Rebtel Shoppers",
    "Actual value": "Rebtel"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Simple Mobile Shoppers",
    "Actual value": "Simple_Mobile"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Straight Talk Shoppers",
    "Actual value": "Straight_Talk"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Total By Verizon Shoppers",
    "Actual value": "Total_By_Verizon"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Tracfone Shoppers",
    "Actual value": "Tracfone"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Viasat Shoppers",
    "Actual value": "Viasat"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Visible Shoppers",
    "Actual value": "Visible"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Wireless Products & Services - Zoom Shoppers",
    "Actual value": "Zoom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Tickets Marketplace - Gametime Shoppers",
    "Actual value": "Gametime"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Tickets Marketplace - Seatgeek Shoppers",
    "Actual value": "Seatgeek"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Tickets Marketplace - Tickpick Shoppers",
    "Actual value": "Tickpick"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Entertainment - Tickets Marketplace - Vivid Seats Shoppers",
    "Actual value": "Vivid_Seats"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Road Tolls & Passes - Good To Go Shoppers",
    "Actual value": "Good_To_Go"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Online Travel Agency - Get Your Guide Shoppers",
    "Actual value": "Get_Your_Guide"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Online Travel Agency - Globa.Li Shoppers",
    "Actual value": "GlobaLi"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Online Travel Agency - Trip.Com Shoppers",
    "Actual value": "TripCom"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Online Travel Agency - Viator Shoppers",
    "Actual value": "Viator"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Travel - Online Travel Agency - Vrbo Shoppers",
    "Actual value": "Vrbo"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Utilities - Direct Energy Shoppers",
    "Actual value": "Direct_Energy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Utilities - Edison International Shoppers",
    "Actual value": "Edison_International"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Utilities - Reliant Energy Shoppers",
    "Actual value": "Reliant_Energy"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Moneygram Shoppers",
    "Actual value": "Moneygram"
  },
  {
    "Filter L1": "AFS Brands",
    "Filter Display value": "Consumer Services - Money Transfer & Remittances - Western Union Shoppers",
    "Actual value": "Western_Union"
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Coach Shoppers',
    'Actual value': 'Coach',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Guess Shoppers',
    'Actual value': 'Guess',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Jewelry Stores - Kay Jewelers Shoppers',
    'Actual value': 'Kay_Jewelers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Jewelry Stores - Jared The Galleria of Jewelry Shoppers',
    'Actual value': 'Jared_The_Galleria_of_Jewelry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Jewelry Stores - Tiffany & Co. Shoppers',
    'Actual value': 'Tiffany__and__Co',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Jewelry Stores - Zales Shoppers',
    'Actual value': 'Zales',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - DSW Shoppers',
    'Actual value': 'DSW',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Famous Footwear Shoppers',
    'Actual value': 'Famous_Footwear',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Foot Locker Shoppers',
    'Actual value': 'Foot_Locker',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Zappos Shoppers',
    'Actual value': 'Zappos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Skechers Shoppers',
    'Actual value': 'Skechers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - JoS. A. Bank Clothiers Shoppers",
    'Actual value': 'JoS_A_Bank_Clothiers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Victoria's Secret Shoppers",
    'Actual value': 'Victorias_Secret',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Women's Clothing & Dresses - Zara Shoppers",
    'Actual value': 'Zara',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Ann Taylor Shoppers",
    'Actual value': 'Ann_Taylor',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Athleta Shoppers',
    'Actual value': 'Athleta',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - David's Bridal Shoppers",
    'Actual value': 'Davids_Bridal',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Discount Clothing Stores - Marshalls Shoppers',
    'Actual value': 'Marshalls',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Discount Clothing Stores - TJ Maxx Shoppers',
    'Actual value': 'TJ_Maxx',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Discount Clothing Stores - Burlington Shoppers',
    'Actual value': 'Burlington',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Discount Clothing Stores - Ross Stores Shoppers',
    'Actual value': 'Ross_Stores',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Discount Clothing Stores - Five Below Shoppers',
    'Actual value': 'Five_Below',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Discount Variety Stores - Ocean State Job Lot Shoppers',
    'Actual value': 'Ocean_State_Job_Lot',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Discount Variety Stores - National Wholesale Liquidators Shoppers',
    'Actual value': 'National_Wholesale_Liquidators',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Discount Variety Stores - Dollar General Shoppers',
    'Actual value': 'Dollar_General',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Discount Variety Stores - Dollar Tree Shoppers',
    'Actual value': 'Dollar_Tree',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Discount Variety Stores - Family Dollar Shoppers',
    'Actual value': 'Family_Dollar',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Discount Variety Stores - Ollies Bargain Outlet Shoppers',
    'Actual value': 'Ollies_Bargain_Outlet',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - L.L.Bean Shoppers',
    'Actual value': 'LLBean',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Clothing & Fashion Retailers - H&M Shoppers',
    'Actual value': 'H_and_M',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Gap Inc. Shoppers',
    'Actual value': 'Gap_Inc',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Hollister Shoppers',
    'Actual value': 'Hollister',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - American Eagle Shoppers',
    'Actual value': 'American_Eagle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Calvin Klein Shoppers',
    'Actual value': 'Calvin_Klein',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Ralph Lauren Shoppers',
    'Actual value': 'Ralph_Lauren',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Old Navy Shoppers',
    'Actual value': 'Old_Navy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Express Shoppers',
    'Actual value': 'Express',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Clothing & Fashion Retailers - Cabela's Shoppers",
    'Actual value': 'Cabelas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Urban Outfitters Shoppers',
    'Actual value': 'Urban_Outfitters',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - J.Crew Shoppers',
    'Actual value': 'JCrew',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Clothing & Fashion Retailers - Lands' End Shoppers",
    'Actual value': 'Lands_End',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Abercrombie & Fitch Shoppers',
    'Actual value': 'Abercrombie__and__Fitch',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Forever 21 Shoppers',
    'Actual value': 'Forever_21',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Michael Kors Shoppers',
    'Actual value': 'Michael_Kors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Brooks Brothers Shoppers',
    'Actual value': 'Brooks_Brothers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - The North Face Shoppers',
    'Actual value': 'The_North_Face',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Charlotte Russe Shoppers',
    'Actual value': 'Charlotte_Russe',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Banana Republic Shoppers',
    'Actual value': 'Banana_Republic',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Department Stores - Dillard's Shoppers",
    'Actual value': 'Dillards',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Belk Shoppers',
    'Actual value': 'Belk',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - J. C. Penney Shoppers',
    'Actual value': 'J_C_Penney',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Department Stores - Kohl's Shoppers",
    'Actual value': 'Kohls',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Department Stores - Macy's Shoppers",
    'Actual value': 'Macys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Sears Shoppers',
    'Actual value': 'Sears',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Nordstrom Shoppers',
    'Actual value': 'Nordstrom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Luxury Fashion Stores - Bloomingdale's Shoppers",
    'Actual value': 'Bloomingdales',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Neiman Marcus Shoppers',
    'Actual value': 'Neiman_Marcus',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Saks Fifth Avenue Shoppers',
    'Actual value': 'Saks_Fifth_Avenue',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Lord & Taylor Shoppers',
    'Actual value': 'Lord__and__Taylor',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Drug Stores & Pharmacy - Walgreens Shoppers',
    'Actual value': 'Walgreens',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Drug Stores & Pharmacy - CVS Pharmacy Shoppers',
    'Actual value': 'CVS_Pharmacy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Drug Stores & Pharmacy - Rite Aid Shoppers',
    'Actual value': 'Rite_Aid',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Vitamins & Supplements - GNC Shoppers',
    'Actual value': 'GNC',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Vitamins & Supplements - Vitamin Shoppe Shoppers',
    'Actual value': 'Vitamin_Shoppe',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Drug Stores & Pharmacy - Duane Reade- Walgreens Shoppers',
    'Actual value': 'Duane_Reade-_Walgreens',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Best Buy Customers',
    'Actual value': 'Best_Buy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Radio Shack Customers',
    'Actual value': 'Radio_Shack',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Office, Electronics, Games - Computers & Electronics - Fry's Electronics Customers",
    'Actual value': 'Frys_Electronics',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Apple Customers',
    'Actual value': 'Apple',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Computers & Electronics - Dell Customers',
    'Actual value': 'Dell',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Microsoft Customers',
    'Actual value': 'Microsoft',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Software Services - Adobe Systems Customers',
    'Actual value': 'Adobe_Systems',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - 7 Eleven Shoppers',
    'Actual value': '7_Eleven',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - QuikTrip Shoppers',
    'Actual value': 'QuikTrip',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Circle K Shoppers',
    'Actual value': 'Circle_K',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Sheetz Shoppers',
    'Actual value': 'Sheetz',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Wawa Shoppers',
    'Actual value': 'Wawa',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Kwik Trip Shoppers',
    'Actual value': 'Kwik_Trip',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Plaid Pantry Shoppers',
    'Actual value': 'Plaid_Pantry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Kwik Shop Shoppers',
    'Actual value': 'Kwik_Shop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Safeway Shoppers',
    'Actual value': 'Safeway',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Kroger Shoppers',
    'Actual value': 'Kroger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Trader Joe's Shoppers",
    'Actual value': 'Trader_Joes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Whole Foods Market Shoppers',
    'Actual value': 'Whole_Foods_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Hy-Vee Shoppers',
    'Actual value': 'Hy-Vee',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - ShopRite Shoppers',
    'Actual value': 'ShopRite',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Ralphs Kroger Shoppers',
    'Actual value': 'Ralphs_Kroger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Harris Teeter Shoppers',
    'Actual value': 'Harris_Teeter',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - King Soopers Shoppers',
    'Actual value': 'King_Soopers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Fred Meyer Shoppers',
    'Actual value': 'Fred_Meyer',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Smith's Shoppers",
    'Actual value': 'Smiths',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Wegmans Shoppers',
    'Actual value': 'Wegmans',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Stater Bros. Markets Shoppers',
    'Actual value': 'Stater_Bros_Markets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Fry's Food Stores Shoppers",
    'Actual value': 'Frys_Food_Stores',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Market Basket Shoppers',
    'Actual value': 'Market_Basket',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Raley's Shoppers",
    'Actual value': 'Raleys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - City Market-Kroger Shoppers',
    'Actual value': 'City_Market-Kroger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Dillons-Kroger Shoppers',
    'Actual value': 'Dillons-Kroger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Fareway Shoppers',
    'Actual value': 'Fareway',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Fairway Market Shoppers',
    'Actual value': 'Fairway_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Quality Food Centers Shoppers',
    'Actual value': 'Quality_Food_Centers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Key Food Shoppers',
    'Actual value': 'Key_Food',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Stop & Shop Shoppers',
    'Actual value': 'Stop__and__Shop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Baker's-Kroger Shoppers",
    'Actual value': 'Bakers-Kroger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Publix Shoppers',
    'Actual value': 'Publix',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Pay-Less Supermarkets Shoppers',
    'Actual value': 'Pay-Less_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - JayC Food Stores Shoppers',
    'Actual value': 'JayC_Food_Stores',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Gerbes Super Markets Shoppers',
    'Actual value': 'Gerbes_Super_Markets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Arts & Craft Stores - Michaels Shoppers',
    'Actual value': 'Michaels',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Crate & Barrel Shoppers',
    'Actual value': 'Crate__and__Barrel',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Williams Sonoma Shoppers',
    'Actual value': 'Williams_Sonoma',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Pottery Barn Shoppers',
    'Actual value': 'Pottery_Barn',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Pier 1 Imports Shoppers',
    'Actual value': 'Pier_1_Imports',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Home - Home Furnishing & Decor Stores - Havertys Furniture Company Shoppers',
    'Actual value': 'Havertys_Furniture_Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - IKEA Shoppers',
    'Actual value': 'IKEA',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - HomeGoods Shoppers',
    'Actual value': 'HomeGoods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Rooms To Go Shoppers',
    'Actual value': 'Rooms_To_Go',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Raymour & Flanigan Shoppers',
    'Actual value': 'Raymour__and__Flanigan',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Bed Bath & Beyond Shoppers',
    'Actual value': 'Bed_Bath__and__Beyond',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Art Van Furniture Shoppers',
    'Actual value': 'Art_Van_Furniture',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Home - Home Furnishing & Decor Stores - Bob's Discount Furniture Shoppers",
    'Actual value': 'Bobs_Discount_Furniture',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Restoration Hardware Shoppers',
    'Actual value': 'Restoration_Hardware',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Home - Home Furnishing & Decor Stores - Cost Plus World Market Shoppers',
    'Actual value': 'Cost_Plus_World_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - True Value Shoppers',
    'Actual value': 'True_Value',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Home Depot Shoppers',
    'Actual value': 'Home_Depot',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Home - Home Improvement Stores - Lowe's Shoppers",
    'Actual value': 'Lowes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Ace Hardware Shoppers',
    'Actual value': 'Ace_Hardware',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Sherwin Williams Shoppers',
    'Actual value': 'Sherwin_Williams',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Harbor Freight Tools Shoppers',
    'Actual value': 'Harbor_Freight_Tools',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Menards Shoppers',
    'Actual value': 'Menards',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Retail Warehouse Clubs - Costco Shoppers',
    'Actual value': 'Costco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Retail Warehouse Clubs - Sam's Club Shoppers",
    'Actual value': 'Sams_Club',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Food & Pharmacy - Retail Warehouse Clubs - BJ's Wholesale Club Shoppers",
    'Actual value': 'BJs_Wholesale_Club',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Big Box Stores - Target Shoppers',
    'Actual value': 'Target',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Big Box Stores - Kmart Shoppers',
    'Actual value': 'Kmart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Big Box Stores - Walmart Shoppers',
    'Actual value': 'Walmart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Big Box Stores - Meijer Shoppers',
    'Actual value': 'Meijer',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Amazon Customers',
    'Actual value': 'Amazon',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Overstock Customers',
    'Actual value': 'Overstock',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - eBay Customers',
    'Actual value': 'eBay',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Etsy Customers',
    'Actual value': 'Etsy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Buy Buy Baby Customers',
    'Actual value': 'Buy_Buy_Baby',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Groupon Customers',
    'Actual value': 'Groupon',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Living Social Customers',
    'Actual value': 'Living_Social',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Hallmark Shoppers',
    'Actual value': 'Hallmark',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Harry & David Shoppers',
    'Actual value': 'Harry__and__David',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Barnes & Noble Shoppers',
    'Actual value': 'Barnes__and__Noble',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - Carter's Shoppers",
    'Actual value': 'Carters',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Children\'s Clothing & Toys - Toys "R" Us Shoppers',
    'Actual value': 'Toys_""R""_Us',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - 24 Hour Fitness Members',
    'Actual value': '24_Hour_Fitness',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Weight Loss Services - Weight Watchers Members',
    'Actual value': 'Weight_Watchers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Consumer Services - Health & Fitness - Gold's Gym Members",
    'Actual value': 'Golds_Gym',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Office Supply Stores - Staples Shoppers',
    'Actual value': 'Staples',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Office Supply Stores - Office Depot Shoppers',
    'Actual value': 'Office_Depot',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Pet Smart Shoppers',
    'Actual value': 'Pet_Smart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Petco Shoppers',
    'Actual value': 'Petco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Specialty Retail - Sporting Goods & Outdoors - Dick's Sporting Goods Shoppers",
    'Actual value': 'Dicks_Sporting_Goods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Nike Shoppers',
    'Actual value': 'Nike',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - REI Shoppers',
    'Actual value': 'REI',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Bass Pro Shops Shoppers',
    'Actual value': 'Bass_Pro_Shops',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Specialty Retail - Sporting Goods & Outdoors - Modell's Sporting Goods Shoppers",
    'Actual value': 'Modells_Sporting_Goods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Golf Galaxy Shoppers',
    'Actual value': 'Golf_Galaxy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - GameStop Shoppers',
    'Actual value': 'GameStop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Online Gaming - PlayStation Store Shoppers',
    'Actual value': 'PlayStation_Store',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - Big Fish Games Shoppers',
    'Actual value': 'Big_Fish_Games',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - AutoZone Shoppers',
    'Actual value': 'AutoZone',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Automotive - Auto Parts Retailers - O'Reilly Auto Parts Shoppers",
    'Actual value': 'OReilly_Auto_Parts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - Advance Auto Parts Shoppers',
    'Actual value': 'Advance_Auto_Parts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - Pep Boys Shoppers',
    'Actual value': 'Pep_Boys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Goodyear Tire Shoppers',
    'Actual value': 'Goodyear_Tire',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - Napa Auto Parts Shoppers',
    'Actual value': 'Napa_Auto_Parts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Discount Tire Direct Shoppers',
    'Actual value': 'Discount_Tire_Direct',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Shell Shoppers',
    'Actual value': 'Shell',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - ExxonMobil Shoppers',
    'Actual value': 'ExxonMobil',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Chevron Shoppers',
    'Actual value': 'Chevron',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Sunoco Shoppers',
    'Actual value': 'Sunoco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Automotive - Gas & Service Stations - Marathon Petroleum Corporation Shoppers',
    'Actual value': 'Marathon_Petroleum_Corporation',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Citgo Shoppers',
    'Actual value': 'Citgo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Gulf Oil Shoppers',
    'Actual value': 'Gulf_Oil',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - BP Shoppers',
    'Actual value': 'BP',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Conoco Shoppers',
    'Actual value': 'Conoco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Valero Shoppers',
    'Actual value': 'Valero',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Hess Shoppers',
    'Actual value': 'Hess',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - AMC Theatres Customers',
    'Actual value': 'AMC_Theatres',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - Regal Cinemas Customers',
    'Actual value': 'Regal_Cinemas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Tickets Marketplace - Fandango Customers',
    'Actual value': 'Fandango',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - Cinemark Theatres Customers',
    'Actual value': 'Cinemark_Theatres',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - MovieTickets.com Customers',
    'Actual value': 'MovieTicketscom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Six Flags Visitors',
    'Actual value': 'Six_Flags_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Sea World Visitors',
    'Actual value': 'Sea_World_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Disney World/Land Visitors',
    'Actual value': 'Disney_World/Land_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - DirecTV Customers',
    'Actual value': 'DirecTV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - Comcast Xfinity Customers',
    'Actual value': 'Comcast_Xfinity',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - DishTV Customers',
    'Actual value': 'DishTV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Tickets Marketplace - Ticketmaster Customers',
    'Actual value': 'Ticketmaster',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Tickets Marketplace - StubHub Customers',
    'Actual value': 'StubHub',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - iTunes Subscribers',
    'Actual value': 'iTunes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Amazon Prime Subscribers',
    'Actual value': 'Amazon_Prime',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Netflix Subscribers',
    'Actual value': 'Netflix',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Sirius XM Subscribers',
    'Actual value': 'Sirius_XM',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Hulu Subscribers',
    'Actual value': 'Hulu',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Vudu Subscribers',
    'Actual value': 'Vudu',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Pandora Subscribers',
    'Actual value': 'Pandora',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Spotify Subscribers',
    'Actual value': 'Spotify',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Amazon VOD Subscribers',
    'Actual value': 'Amazon_VOD',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Tax Act Customers',
    'Actual value': 'Tax_Act',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - H&R Block Customers',
    'Actual value': 'H_and_R_Block',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - TurboTax Customers',
    'Actual value': 'TurboTax',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Quicken Customers',
    'Actual value': 'Quicken',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Shipping & Tracking - UPS Customers',
    'Actual value': 'UPS',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Shipping & Tracking - USPS Customers',
    'Actual value': 'USPS',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Shipping & Tracking - FedEx Customers',
    'Actual value': 'FedEx',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Geico Customers',
    'Actual value': 'Geico',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Insurance Providers - Travelers Insurance Customers',
    'Actual value': 'Travelers_Insurance',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - State Farm Customers',
    'Actual value': 'State_Farm',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Progressive Customers',
    'Actual value': 'Progressive',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Allstate Customers',
    'Actual value': 'Allstate',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Nationwide Customers',
    'Actual value': 'Nationwide',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Farmers Insurance Customers',
    'Actual value': 'Farmers_Insurance',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Esurance Customers',
    'Actual value': 'Esurance',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Fine Dining - Ruth's Chris Steak House Customers",
    'Actual value': 'Ruths_Chris_Steak_House',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Fine Dining - Fleming's Prime Steakhouse Customers",
    'Actual value': 'Flemings_Prime_Steakhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Fine Dining - Morton's The Steakhouse Customers",
    'Actual value': 'Mortons_The_Steakhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Casual Restaurants - P.F. Chang's Customers",
    'Actual value': 'PF_Changs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Bonefish Customers',
    'Actual value': 'Bonefish',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Applebees Neighborhood Grill & Bar Restaurant Customers',
    'Actual value': 'Applebees_Neighborhood_Grill__and__Bar_Restaurant',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Olive Garden Customers',
    'Actual value': 'Olive_Garden',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - IHOP Customers',
    'Actual value': 'IHOP',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Casual Restaurants - Denny's Customers",
    'Actual value': 'Dennys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Red Lobster Customers',
    'Actual value': 'Red_Lobster',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Red Robin Customers',
    'Actual value': 'Red_Robin',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Golden Corral Customers',
    'Actual value': 'Golden_Corral',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Ruby Tuesday Customers',
    'Actual value': 'Ruby_Tuesday',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - TGI Fridays Customers',
    'Actual value': 'TGI_Fridays',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Bob Evans Restaurant Customers',
    'Actual value': 'Bob_Evans_Restaurant',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Carrabba's Italian Grill Customers",
    'Actual value': 'Carrabbas_Italian_Grill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Hooters Customers',
    'Actual value': 'Hooters',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Smokey Bones Customers',
    'Actual value': 'Smokey_Bones',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - La Madeleine Customers',
    'Actual value': 'La_Madeleine',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Chili's Grill & Bar Customers",
    'Actual value': 'Chilis_Grill__and__Bar',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Dave & Buster's Customers",
    'Actual value': 'Dave__and__Busters',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Casual Restaurants - Fazoli's Customers",
    'Actual value': 'Fazolis',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Outback Steakhouse Customers',
    'Actual value': 'Outback_Steakhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - LongHorn Steakhouse Customers',
    'Actual value': 'LongHorn_Steakhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Ponderosa Steakhouse and Bonanza Steakhouse Customers',
    'Actual value': 'Ponderosa_Steakhouse_and_Bonanza_Steakhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Buffalo Wild Wings Customers',
    'Actual value': 'Buffalo_Wild_Wings',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Panera Bread Customers',
    'Actual value': 'Panera_Bread',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Boston Market Customers',
    'Actual value': 'Boston_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Smash Burger Customers',
    'Actual value': 'Smash_Burger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Potbelly Sandwich Shop Customers',
    'Actual value': 'Potbelly_Sandwich_Shop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Jason's Deli Customers",
    'Actual value': 'Jasons_Deli',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Corner Bakery Customers',
    'Actual value': 'Corner_Bakery',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Cosi Customers',
    'Actual value': 'Cosi',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Carvel Customers',
    'Actual value': 'Carvel',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - McDonald's Customers",
    'Actual value': 'McDonalds',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Subway Customers',
    'Actual value': 'Subway',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Starbucks Customers',
    'Actual value': 'Starbucks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Wendy's Customers",
    'Actual value': 'Wendys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Taco Bell Customers',
    'Actual value': 'Taco_Bell',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Burger King Customers',
    'Actual value': 'Burger_King',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Chick-fil-A Customers',
    'Actual value': 'Chick-fil-A',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Ice Cream Shops - Dairy Queen Customers',
    'Actual value': 'Dairy_Queen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - KFC Customers',
    'Actual value': 'KFC',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Pizza Hut Customers',
    'Actual value': 'Pizza_Hut',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Arby's Customers",
    'Actual value': 'Arbys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Domino's Pizza Customers",
    'Actual value': 'Dominos_Pizza',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Chipotle Mexican Grill Customers',
    'Actual value': 'Chipotle_Mexican_Grill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Little Caesars Pizza Customers',
    'Actual value': 'Little_Caesars_Pizza',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Dunkin' Donuts Customers",
    'Actual value': 'Dunkin_Donuts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Popeyes Customers',
    'Actual value': 'Popeyes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Jimmy John's Customers",
    'Actual value': 'Jimmy_Johns',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Papa John's Pizza Customers",
    'Actual value': 'Papa_Johns_Pizza',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Hardee's Customers",
    'Actual value': 'Hardees',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - In-N-Out Burger Customers',
    'Actual value': 'In-N-Out_Burger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Carl's Jr. Customers",
    'Actual value': 'Carls_Jr',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Quiznos Customers',
    'Actual value': 'Quiznos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Cold Stone Creamery Customers',
    'Actual value': 'Cold_Stone_Creamery',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Ice Cream Shops - Cold Stone Creamery Shoppers',
    'Actual value': '',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Peet's Coffee Customers",
    'Actual value': 'Peets_Coffee',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - The Coffee Bean & Tea Leaf Customers',
    'Actual value': 'The_Coffee_Bean__and__Tea_Leaf',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Krispy Kreme Customers',
    'Actual value': 'Krispy_Kreme',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Sonic Drive-In Customers',
    'Actual value': 'Sonic_Drive-In',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Ulta Beauty Shoppers',
    'Actual value': 'Ulta_Beauty',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Sephora Shoppers',
    'Actual value': 'Sephora',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Online Flower Delivery - Teleflora Customers',
    'Actual value': 'Teleflora',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Online Flower Delivery - 1800Flowers Customers',
    'Actual value': '1800Flowers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Online Flower Delivery - ProFlowers Customers',
    'Actual value': 'ProFlowers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Lens Crafters Shoppers',
    'Actual value': 'Lens_Crafters',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Sunglass Hut Shoppers',
    'Actual value': 'Sunglass_Hut',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - AT&T Customers',
    'Actual value': 'AT_and_T',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - Sprint Customers',
    'Actual value': 'Sprint',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - T-Mobile Customers',
    'Actual value': 'T-Mobile',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Wireless Products & Services - Cricket Wireless Customers',
    'Actual value': 'Cricket_Wireless',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Wireless Products & Services - Virgin Mobile Customers',
    'Actual value': 'Virgin_Mobile',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - Verizon Customers',
    'Actual value': 'Verizon',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Expedia Customers',
    'Actual value': 'Expedia',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Priceline Customers',
    'Actual value': 'Priceline',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Travelocity Customers',
    'Actual value': 'Travelocity',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Orbitz Customers',
    'Actual value': 'Orbitz',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Hotels.com Customers',
    'Actual value': 'Hotelscom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Norwegian Cruise Line Customers',
    'Actual value': 'Norwegian_Cruise_Line',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Carnival Cruise Line Customers',
    'Actual value': 'Carnival_Cruise_Line',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Royal Caribbean International Customers',
    'Actual value': 'Royal_Caribbean_International',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Luxury Hotels - Westin Hotels & Resorts Customers',
    'Actual value': 'Westin_Hotels__and__Resorts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Luxury Hotels - Ritz Carlton Customers',
    'Actual value': 'Ritz_Carlton',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Marriott Customers',
    'Actual value': 'Marriott',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Airbnb Customers',
    'Actual value': 'Airbnb',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Hilton Hotels & Resorts Customers',
    'Actual value': 'Hilton_Hotels__and__Resorts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Courtyard by Marriott Customers',
    'Actual value': 'Courtyard_by_Marriott',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Holiday Inn Customers',
    'Actual value': 'Holiday_Inn',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Hampton Inn Customers',
    'Actual value': 'Hampton_Inn',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Hilton Garden Inn Customers',
    'Actual value': 'Hilton_Garden_Inn',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - DoubleTree by Hilton Customers',
    'Actual value': 'DoubleTree_by_Hilton',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Residence Inn Marriott Customers',
    'Actual value': 'Residence_Inn_Marriott',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Sheraton Customers',
    'Actual value': 'Sheraton',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Homewood Suites Customers',
    'Actual value': 'Homewood_Suites',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Embassy Suites Customers',
    'Actual value': 'Embassy_Suites',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Renaissance Hotels Customers',
    'Actual value': 'Renaissance_Hotels',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - SpringHill Suites Customers',
    'Actual value': 'SpringHill_Suites',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Le Meridien Customers',
    'Actual value': 'Le_Meridien',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Mid-tier Hotels - Hyatt Regency Customers',
    'Actual value': 'Hyatt_Regency',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Economy Hotels - Best Western Customers',
    'Actual value': 'Best_Western',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Economy Hotels - Comfort Inn/Suites Customers',
    'Actual value': 'Comfort_Inn/Suites',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Economy Hotels - Quality Inn Customers',
    'Actual value': 'Quality_Inn',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Economy Hotels - Motel 6 Customers',
    'Actual value': 'Motel_6',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Economy Hotels - Fairfield Inn & Suites Marriott Customers',
    'Actual value': 'Fairfield_Inn__and__Suites_Marriott',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Delta Airlines Customers',
    'Actual value': 'Delta_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - United Airlines Customers',
    'Actual value': 'United_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Southwest Airlines Customers',
    'Actual value': 'Southwest_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - American Airlines Customers',
    'Actual value': 'American_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - JetBlue Customers',
    'Actual value': 'JetBlue',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Frontier Airlines Customers',
    'Actual value': 'Frontier_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Hertz Customers',
    'Actual value': 'Hertz',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Alamo Customers',
    'Actual value': 'Alamo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Avis Rent a Car Customers',
    'Actual value': 'Avis_Rent_a_Car',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Budget Rent a Car Customers',
    'Actual value': 'Budget_Rent_a_Car',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Enterprise Rent-A-Car Customers',
    'Actual value': 'Enterprise_Rent-A-Car',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Men's Wearhouse Shoppers",
    'Actual value': 'Mens_Wearhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Sling TV Customers',
    'Actual value': 'Sling_TV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Pacific Sunwear Shoppers',
    'Actual value': 'Pacific_Sunwear',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Children's Clothing & Toys - Crazy 8 Shoppers",
    'Actual value': 'Crazy_8',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - Gymboree Shoppers",
    'Actual value': 'Gymboree',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Children's Clothing & Toys - Justice Shoppers",
    'Actual value': 'Justice',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - Oshkosh B'gosh Shoppers",
    'Actual value': 'Oshkosh_Bgosh',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - The Children's Place Shoppers",
    'Actual value': 'The_Childrens_Place',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Nordstrom Rack Shoppers',
    'Actual value': 'Nordstrom_Rack',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Visionworks Shoppers',
    'Actual value': 'Visionworks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Lululemon Shoppers',
    'Actual value': 'Lululemon',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Anthropologie Shoppers",
    'Actual value': 'Anthropologie',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Women's Clothing & Dresses - Chico's Shoppers",
    'Actual value': 'Chicos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Christopher & Banks Shoppers",
    'Actual value': 'Christopher__and__Banks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Lane Bryant Shoppers",
    'Actual value': 'Lane_Bryant',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Motherhood Maternity Shoppers",
    'Actual value': 'Motherhood_Maternity',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - New York & Company Shoppers",
    'Actual value': 'New_York__and__Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Women's Clothing & Dresses - Soma Shoppers",
    'Actual value': 'Soma',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Women's Clothing & Dresses - Talbots Shoppers",
    'Actual value': 'Talbots',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - White House Black Market Shoppers",
    'Actual value': 'White_House_Black_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - Car Quest Shoppers',
    'Actual value': 'Car_Quest',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Service & Repair - Jiffy Lube Shoppers',
    'Actual value': 'Jiffy_Lube',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Service & Repair - Midas Shoppers',
    'Actual value': 'Midas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Tire Kingdom Shoppers',
    'Actual value': 'Tire_Kingdom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Tires Plus Shoppers',
    'Actual value': 'Tires_Plus',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Automotive - Auto Service & Repair - Valvoline Instant Oil Change Shoppers',
    'Actual value': 'Valvoline_Instant_Oil_Change',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Automotive - Gas & Service Stations - BJ's Wholesale Club Fuel Shoppers",
    'Actual value': 'BJs_Wholesale_Club_Fuel',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Wawa Gas Shoppers',
    'Actual value': 'Wawa_Gas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Cable, Satellite & TV - Charter Communications Customers',
    'Actual value': 'Charter_Communications',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - Optimum Customers',
    'Actual value': 'Optimum',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - U.S. Cellular Customers',
    'Actual value': 'US_Cellular',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - LA Fitness Members',
    'Actual value': 'LA_Fitness',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - Planet Fitness Members',
    'Actual value': 'Planet_Fitness',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - Century Theatres Customers',
    'Actual value': 'Century_Theatres',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - Marquee Cinemas Customers',
    'Actual value': 'Marquee_Cinemas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Movies & Films - United Artists Theatres Customers',
    'Actual value': 'United_Artists_Theatres',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Vitamins & Supplements - Vitacost Shoppers',
    'Actual value': 'Vitacost',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Haggen Food & Pharmacy Shoppers',
    'Actual value': 'Haggen_Food__and__Pharmacy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Drug Stores & Pharmacy - The Honest Company Shoppers',
    'Actual value': 'The_Honest_Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Albertsons Shoppers',
    'Actual value': 'Albertsons',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Aldi Supermarkets Shoppers',
    'Actual value': 'Aldi_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Bi-Lo Shoppers',
    'Actual value': 'Bi-Lo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Food 4 Less Shoppers',
    'Actual value': 'Food_4_Less',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Food Lion Shoppers',
    'Actual value': 'Food_Lion',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Giant Food Inc. Shoppers',
    'Actual value': 'Giant_Food_Inc',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Grocery Stores - Hannaford Brothers Company Shoppers',
    'Actual value': 'Hannaford_Brothers_Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - HEB Grocery Shoppers',
    'Actual value': 'HEB_Grocery',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - IGA Shoppers',
    'Actual value': 'IGA',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Lowes Foods Shoppers',
    'Actual value': 'Lowes_Foods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Lucky Stores Shoppers',
    'Actual value': 'Lucky_Stores',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Pavilion Shoppers',
    'Actual value': 'Pavilion',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Grocery Stores - Price Chopper Supermarkets Shoppers',
    'Actual value': 'Price_Chopper_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Randalls Shoppers',
    'Actual value': 'Randalls',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Shaw's Supermarkets Shoppers",
    'Actual value': 'Shaws_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Star Market Shoppers',
    'Actual value': 'Star_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - SuperValu Shoppers',
    'Actual value': 'SuperValu',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Tom Thumb Shoppers',
    'Actual value': 'Tom_Thumb',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - United Supermarkets Shoppers',
    'Actual value': 'United_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Vons Shoppers',
    'Actual value': 'Vons',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Weis Market Shoppers',
    'Actual value': 'Weis_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Winn-Dixie Shoppers',
    'Actual value': 'Winn-Dixie',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Food & Pharmacy - Grocery Stores - Shop 'N Save Warehouse Foods Shoppers",
    'Actual value': 'Shop_N_Save_Warehouse_Foods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - Zulily Customers',
    'Actual value': 'Zulily',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Newegg Customers',
    'Actual value': 'Newegg',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - California Pizza Kitchen Customers',
    'Actual value': 'California_Pizza_Kitchen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - The Cheesecake Factory Customers',
    'Actual value': 'The_Cheesecake_Factory',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Chuck E. Cheese's Customers",
    'Actual value': 'Chuck_E_Cheeses',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Cracker Barrel Customers',
    'Actual value': 'Cracker_Barrel',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Five Guys Customers',
    'Actual value': 'Five_Guys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Grubhub Customers',
    'Actual value': 'Grubhub',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Joe's Crab Shack Customers",
    'Actual value': 'Joes_Crab_Shack',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Panda Express Customers',
    'Actual value': 'Panda_Express',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Papa Murphy's Customers",
    'Actual value': 'Papa_Murphys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Tim Hortons Customers',
    'Actual value': 'Tim_Hortons',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Bare Minerals Shoppers',
    'Actual value': 'Bare_Minerals',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Beauty Cosmetics Stores - Sally Beauty Supply Shoppers',
    'Actual value': 'Sally_Beauty_Supply',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Online Flower Delivery - FTD Customers',
    'Actual value': 'FTD',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Gifts & Party Retailers - Bath & Body Works Shoppers',
    'Actual value': 'Bath__and__Body_Works',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Gifts & Party Retailers - Edible Arrangements Shoppers',
    'Actual value': 'Edible_Arrangements',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Party City Shoppers',
    'Actual value': 'Party_City',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Specialty Retail - Gifts & Party Retailers - Shari's Berries Shoppers",
    'Actual value': 'Sharis_Berries',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Chewy Shoppers',
    'Actual value': 'Chewy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Pet Supermarket Shoppers',
    'Actual value': 'Pet_Supermarket',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Pet Supplies Plus Shoppers',
    'Actual value': 'Pet_Supplies_Plus',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Pet Valu Shoppers',
    'Actual value': 'Pet_Valu',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Pet Sense Shoppers',
    'Actual value': 'Pet_Sense',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Alaska Airlines Customers',
    'Actual value': 'Alaska_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Lyft Customers',
    'Actual value': 'Lyft',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - CheapOair Customers',
    'Actual value': 'CheapOair',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Gander Outdoors Shoppers',
    'Actual value': 'Gander_Outdoors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Cable, Satellite & TV - Cox Communications Customers',
    'Actual value': 'Cox_Communications',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Wireless Products & Services - Metro by T-Mobile Customers',
    'Actual value': 'Metro_by_T-Mobile',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Drug Stores & Pharmacy - The Medicine Shoppe Shoppers',
    'Actual value': 'The_Medicine_Shoppe',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Uber Customers',
    'Actual value': 'Uber',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Mattress Stores - Mattress Firm Shoppers',
    'Actual value': 'Mattress_Firm',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Joss & Main Shoppers',
    'Actual value': 'Joss__and__Main',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Rural King Shoppers',
    'Actual value': 'Rural_King',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Under Armour Shoppers',
    'Actual value': 'Under_Armour',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - CB2 Shoppers',
    'Actual value': 'CB2',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Birch Lane Shoppers',
    'Actual value': 'Birch_Lane',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - FRONTGATE Shoppers',
    'Actual value': 'FRONTGATE',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Ballard Designs Shoppers',
    'Actual value': 'Ballard_Designs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - MAC Cosmetics Shoppers',
    'Actual value': 'MAC_Cosmetics',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Spirit Airlines Customers',
    'Actual value': 'Spirit_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Computers & Electronics - HP Customers',
    'Actual value': 'HP',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Moving & Storage Services - U-Haul Customers',
    'Actual value': 'U-Haul',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Moving & Storage Services - Public Storage Customers',
    'Actual value': 'Public_Storage',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Moving & Storage Services - Extra Space Storage Customers',
    'Actual value': 'Extra_Space_Storage',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Moving & Storage Services - CubeSmart Customers',
    'Actual value': 'CubeSmart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Moving & Storage Services - Life Storage Customers',
    'Actual value': 'Life_Storage',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - west elm Shoppers',
    'Actual value': 'west_elm',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Room & Board Shoppers',
    'Actual value': 'Room__and__Board',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Living Spaces Shoppers',
    'Actual value': 'Living_Spaces',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Ashley HomeStore Shoppers',
    'Actual value': 'Ashley_HomeStore',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Wayfair Shoppers',
    'Actual value': 'Wayfair',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Discount Variety Stores - Big Lots! Shoppers',
    'Actual value': 'Big_Lots!',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Giant Eagle Shoppers',
    'Actual value': 'Giant_Eagle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Piggly Wiggly Shoppers',
    'Actual value': 'Piggly_Wiggly',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Save A Lot Shoppers',
    'Actual value': 'Save_A_Lot',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Sprouts Farmers Market Shoppers',
    'Actual value': 'Sprouts_Farmers_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - The Fresh Market Shoppers',
    'Actual value': 'The_Fresh_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Disney+ Subscribers',
    'Actual value': 'Disney+',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Sonos Customers',
    'Actual value': 'Sonos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Alcohol Delivery Services - ReserveBar Customers',
    'Actual value': 'ReserveBar',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Alcohol Delivery Services - Drizly Customers',
    'Actual value': 'Drizly',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Uber Eats Customers',
    'Actual value': 'Uber_Eats',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Seamless Customers',
    'Actual value': 'Seamless',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Postmates Customers',
    'Actual value': 'Postmates',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - DoorDash Customers',
    'Actual value': 'DoorDash',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - AmazonFresh Customers',
    'Actual value': 'AmazonFresh',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Fresh Direct Customers',
    'Actual value': 'Fresh_Direct',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Peapod Customers',
    'Actual value': 'Peapod',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Instacart Customers',
    'Actual value': 'Instacart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Shipt Customers',
    'Actual value': 'Shipt',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Food & Pharmacy - Grocery Delivery Services - Walmart Grocery Customers',
    'Actual value': 'Walmart_Grocery',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Thrive Market Customers',
    'Actual value': 'Thrive_Market',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Delivery Services - Mercato Customers',
    'Actual value': 'Mercato',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - CBS Subscribers',
    'Actual value': 'CBS',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - HBO Subscribers',
    'Actual value': 'HBO',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - YouTube TV Subscribers',
    'Actual value': 'YouTube_TV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Fubo TV Subscribers',
    'Actual value': 'Fubo_TV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Bergdorf Goodman Shoppers',
    'Actual value': 'Bergdorf_Goodman',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Wedding Brands Shoppers',
    'Actual value': 'Wedding_Brands',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Zola Registry Customers',
    'Actual value': 'Zola_Registry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - American Girl Shoppers",
    'Actual value': 'American_Girl',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Schnucks Shoppers',
    'Actual value': 'Schnucks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - SoundCloud Subscribers',
    'Actual value': 'SoundCloud',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - Google Play Customers',
    'Actual value': 'Google_Play',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - ACME Markets Shoppers',
    'Actual value': 'ACME_Markets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Intermix Shoppers",
    'Actual value': 'Intermix',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Arts & Craft Stores - JOANN Fabric Shoppers',
    'Actual value': 'JOANN_Fabric',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - Massage Envy Members',
    'Actual value': 'Massage_Envy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Pei Wei Customers',
    'Actual value': 'Pei_Wei',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - The Body Shop Shoppers',
    'Actual value': 'The_Body_Shop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Fanatics Shoppers',
    'Actual value': 'Fanatics',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Specialty Retail - Men's Grooming - Dollar Shave Club Customers",
    'Actual value': 'Dollar_Shave_Club',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Specialty Retail - Men's Grooming - Harry's Customers",
    'Actual value': 'Harrys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Dental Products & Services - Quip Subscribers',
    'Actual value': 'Quip',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Dental Products & Services - SmileDirectClub Subscribers',
    'Actual value': 'SmileDirectClub',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Computers & Electronics - Bose Customers',
    'Actual value': 'Bose',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - SoulCycle Shoppers',
    'Actual value': 'SoulCycle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Murphy USA Shoppers',
    'Actual value': 'Murphy_USA',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Convenience Stores - Casey's Shoppers",
    'Actual value': 'Caseys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Academy Sports + Outdoors Shoppers',
    'Actual value': 'Academy_Sports_+_Outdoors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Texas Roadhouse Customers',
    'Actual value': 'Texas_Roadhouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Jewel-Osco Shoppers',
    'Actual value': 'Jewel-Osco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Audible Subscribers',
    'Actual value': 'Audible',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Scheels All Sports Shoppers',
    'Actual value': 'Scheels_All_Sports',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - HauteLook Customers',
    'Actual value': 'HauteLook',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - QuickBooks Customers',
    'Actual value': 'QuickBooks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Jack in the Box Customers',
    'Actual value': 'Jack_in_the_Box',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - at home Shoppers',
    'Actual value': 'at_home',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Meal Kit Services - HelloFresh Customers',
    'Actual value': 'HelloFresh',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Print & Photography Services - Shutterfly Customers',
    'Actual value': 'Shutterfly',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Cable, Satellite & TV - Frontier Communications Customers',
    'Actual value': 'Frontier_Communications',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Specialty Retail - Sporting Goods & Outdoors - Sportsman's Warehouse Shoppers",
    'Actual value': 'Sportsmans_Warehouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Natural Grocers Shoppers',
    'Actual value': 'Natural_Grocers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Mattress Stores - Sleep Number Shoppers',
    'Actual value': 'Sleep_Number',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Big 5 Sporting Goods Shoppers',
    'Actual value': 'Big_5_Sporting_Goods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Vans Shoppers',
    'Actual value': 'Vans',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Wingstop Customers',
    'Actual value': 'Wingstop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Harveys Shoppers',
    'Actual value': 'Harveys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Adidas Shoppers',
    'Actual value': 'Adidas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - BJ's Restaurants Customers",
    'Actual value': 'BJs_Restaurants',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Cheddar's Scratch Kitchen Customers",
    'Actual value': 'Cheddars_Scratch_Kitchen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Super Saver Shoppers',
    'Actual value': 'Super_Saver',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Topgolf Customers',
    'Actual value': 'Topgolf',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Moving & Storage Services - Penske Customers',
    'Actual value': 'Penske',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Supercuts Shoppers',
    'Actual value': 'Supercuts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - QDOBA Customers',
    'Actual value': 'QDOBA',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - News & Magazines - The New York Times Subscribers',
    'Actual value': 'The_New_York_Times',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Shopbop Customers",
    'Actual value': 'Shopbop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - The Container Store Shoppers',
    'Actual value': 'The_Container_Store',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - Quik Stop Shoppers',
    'Actual value': 'Quik_Stop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Yard House Customers',
    'Actual value': 'Yard_House',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - IPSY Subscribers',
    'Actual value': 'IPSY',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - News & Magazines - Gannett Publishing Subscribers',
    'Actual value': 'Gannett_Publishing',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Ethan Allen Shoppers',
    'Actual value': 'Ethan_Allen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - El Pollo Loco Customers',
    'Actual value': 'El_Pollo_Loco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Fabletics Subscribers',
    'Actual value': 'Fabletics',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Meal Kit Services - Blue Apron Customers',
    'Actual value': 'Blue_Apron',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Meal Kit Services - Home Chef Customers',
    'Actual value': 'Home_Chef',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Del Taco Customers',
    'Actual value': 'Del_Taco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Pearle Vision Shoppers',
    'Actual value': 'Pearle_Vision',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Maggiano's Little Italy Customers",
    'Actual value': 'Maggianos_Little_Italy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - MetLife Customers',
    'Actual value': 'MetLife',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Warby Parker Customers',
    'Actual value': 'Warby_Parker',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Geek Squad Customers',
    'Actual value': 'Geek_Squad',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Service & Repair - Honda Shoppers',
    'Actual value': 'Honda',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Mass Retailers - Online & Mobile Retailers - QVC Customers',
    'Actual value': 'QVC',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Cub Foods Shoppers',
    'Actual value': 'Cub_Foods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - News & Magazines - Traveler Magazine Subscribers',
    'Actual value': 'Traveler_Magazine',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Ingles Markets Shoppers',
    'Actual value': 'Ingles_Markets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Smart & Final Shoppers',
    'Actual value': 'Smart__and__Final',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Market Street Shoppers',
    'Actual value': 'Market_Street',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Pick 'n Save Shoppers",
    'Actual value': 'Pick_n_Save',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Stein Mart Shoppers',
    'Actual value': 'Stein_Mart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Cable, Satellite & TV - Suddenlink Communications Customers',
    'Actual value': 'Suddenlink_Communications',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Martin's Shoppers",
    'Actual value': 'Martins',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Lumber Liquidators Shoppers',
    'Actual value': 'Lumber_Liquidators',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Shoe Carnival Shoppers',
    'Actual value': 'Shoe_Carnival',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Duluth Trading Shoppers',
    'Actual value': 'Duluth_Trading',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Convenience Stores - Loaf 'N Jug Shoppers",
    'Actual value': 'Loaf_N_Jug',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Weight Loss Services - Nutrisystem Members',
    'Actual value': 'Nutrisystem',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Kate Spade Shoppers",
    'Actual value': 'Kate_Spade',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Levi Strauss Shoppers',
    'Actual value': 'Levi_Strauss',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Casual Restaurants - Chuy's Customers",
    'Actual value': 'Chuys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - 1-800-PetMeds Customers',
    'Actual value': '1-800-PetMeds',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Francesca's Shoppers",
    'Actual value': 'Francescas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Noodles & Company Shoppers',
    'Actual value': 'Noodles__and__Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Mr. Tire Shoppers',
    'Actual value': 'Mr_Tire',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Cigna Customers',
    'Actual value': 'Cigna',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Aflac Customers',
    'Actual value': 'Aflac',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Shake Shack Customers',
    'Actual value': 'Shake_Shack',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Weight Loss Services - Jenny Craig Members',
    'Actual value': 'Jenny_Craig',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fine Dining - Fogo de Chao Customers',
    'Actual value': 'Fogo_de_Chao',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Shoppers Food Warehouse Shoppers',
    'Actual value': 'Shoppers_Food_Warehouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Bassett Furniture Shoppers',
    'Actual value': 'Bassett_Furniture',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Jewelry Stores - Blue Nile Customers',
    'Actual value': 'Blue_Nile',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fast Food & QSR - Auntie Anne's Customers",
    'Actual value': 'Auntie_Annes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Service & Repair - Harley-Davidson Shoppers',
    'Actual value': 'Harley-Davidson',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Garnet Hill Shoppers",
    'Actual value': 'Garnet_Hill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Crocs Shoppers',
    'Actual value': 'Crocs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Jewelry Stores - Piercing Pagoda Customers',
    'Actual value': 'Piercing_Pagoda',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Clothing & Fashion Retailers - Gilt Shoppers',
    'Actual value': 'Gilt',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Shoes.com Customers',
    'Actual value': 'Shoescom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Activewear - Patagonia Shoppers',
    'Actual value': 'Patagonia',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - News & Magazines - Hudson News Customers',
    'Actual value': 'Hudson_News',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Home - Home Furnishing & Decor Stores - Kirkland's Shoppers",
    'Actual value': 'Kirklands',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Ice Cream Shops - Haagen-Dazs Shoppers',
    'Actual value': 'Haagen-Dazs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Ice Cream Shops - Ben & Jerry's Shoppers",
    'Actual value': 'Ben__and__Jerrys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Ice Cream Shops - Oberweis Dairy Shoppers',
    'Actual value': 'Oberweis_Dairy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Tractor Supply Company Shoppers',
    'Actual value': 'Tractor_Supply_Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Liberty Mutual Customers',
    'Actual value': 'Liberty_Mutual',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - 76 Shoppers',
    'Actual value': 76,
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - La-Z-Boy Shoppers',
    'Actual value': 'La-Z-Boy',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Wireless Products & Services - Centurylink Customers',
    'Actual value': 'Centurylink',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Wireless Products & Services - Boost Mobile Customers',
    'Actual value': 'Boost_Mobile',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Rent-A-Center Shoppers',
    'Actual value': 'Rent-A-Center',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Champs Shoppers',
    'Actual value': 'Champs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Louis Vuitton Shoppers',
    'Actual value': 'Louis_Vuitton',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Humana Customers',
    'Actual value': 'Humana',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Journeys Shoppers',
    'Actual value': 'Journeys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Discount Variety Stores - Tuesday Morning Shoppers',
    'Actual value': 'Tuesday_Morning',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Bealls Shoppers',
    'Actual value': 'Bealls',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Charitable and Social Services - Salvation Army Donors',
    'Actual value': 'Salvation_Army',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Drug Stores & Pharmacy - Longs Drugs Shoppers',
    'Actual value': 'Longs_Drugs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Maurices Shoppers',
    'Actual value': 'Maurices',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Mass Retailers - Online & Mobile Retailers - Home Shopping Network (HSN) Customers',
    'Actual value': 'Home_Shopping_Network_HSN',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Floor And Decor Shoppers',
    'Actual value': 'Floor_And_Decor',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - FabFitFun Shoppers',
    'Actual value': 'FabFitFun',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Charitable and Social Services - Goodwill Donors',
    'Actual value': 'Goodwill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Zumiez Shoppers',
    'Actual value': 'Zumiez',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Hermes Shoppers',
    'Actual value': 'Hermes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Tillys Shoppers',
    'Actual value': 'Tillys',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Clothing & Fashion Retailers - Cato Shoppers',
    'Actual value': 'Cato',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Tile Shop Shoppers',
    'Actual value': 'Tile_Shop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - The Finish Line Shoppers',
    'Actual value': 'The_Finish_Line',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Advising Services - Home Advisor Customers',
    'Actual value': 'Home_Advisor',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Tory Burch Shoppers',
    'Actual value': 'Tory_Burch',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Habit Burger Grill Customers',
    'Actual value': 'Habit_Burger_Grill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Horn Bacher's Shoppers",
    'Actual value': 'Horn_Bachers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Madewell Shoppers',
    'Actual value': 'Madewell',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Ice Cream Shops - Turkey Hill Shoppers',
    'Actual value': 'Turkey_Hill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Aeropostale Shoppers',
    'Actual value': 'Aeropostale',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - Wow! Customers',
    'Actual value': 'Wow!',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - GUCCI Shoppers',
    'Actual value': 'GUCCI',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Grocery Stores - Mariano's Shoppers",
    'Actual value': 'Marianos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - UGG Shoppers',
    'Actual value': 'UGG',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - J.Jill Shoppers',
    'Actual value': 'JJill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Carnival Supermarket Shoppers',
    'Actual value': 'Carnival_Supermarket',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Medical Services - American Family Care Customers',
    'Actual value': 'American_Family_Care',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fine Dining - Capital Grill Customers',
    'Actual value': 'Capital_Grill',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Citi Trends Shoppers',
    'Actual value': 'Citi_Trends',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Bojangles Customers',
    'Actual value': 'Bojangles',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Zoes Kitchen Customers',
    'Actual value': 'Zoes_Kitchen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Footaction Shoppers',
    'Actual value': 'Footaction',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Blinds.com Shoppers',
    'Actual value': 'Blindscom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Hibbett Sporting Goods Shoppers',
    'Actual value': 'Hibbett_Sporting_Goods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Educational Services - Chegg Customers',
    'Actual value': 'Chegg',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Intuit Customers',
    'Actual value': 'Intuit',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - Vonage Customers',
    'Actual value': 'Vonage',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Banking & Brokerage Services - Fidelity Investments Customers',
    'Actual value': 'Fidelity_Investments',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Vera Bradley Shoppers',
    'Actual value': 'Vera_Bradley',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Lids Shoppers',
    'Actual value': 'Lids',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Eyewear & Sunglasses - National Vision Shoppers',
    'Actual value': 'National_Vision',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Yves Saint Laurent Shoppers',
    'Actual value': 'Yves_Saint_Laurent',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Mathis Brothers Shoppers',
    'Actual value': 'Mathis_Brothers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - Hayneedle Shoppers',
    'Actual value': 'Hayneedle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Ruler Foods Shoppers',
    'Actual value': 'Ruler_Foods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Fossil Shoppers',
    'Actual value': 'Fossil',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Element Shoppers',
    'Actual value': 'Element',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Gifts & Party Retailers - Christmas Tree Shops Shoppers',
    'Actual value': 'Christmas_Tree_Shops',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Tommy Hilfiger Shoppers",
    'Actual value': 'Tommy_Hilfiger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - Fitbit Customers',
    'Actual value': 'Fitbit',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Clothing & Fashion Retailers - Hanes Shoppers',
    'Actual value': 'Hanes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Armani Shoppers',
    'Actual value': 'Armani',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Gifts & Party Retailers - Personalization Mall Customers',
    'Actual value': 'Personalization_Mall',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Casual Restaurants - Bubba's Customers",
    'Actual value': 'Bubbas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Van Heusen Shoppers",
    'Actual value': 'Van_Heusen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Steve Madden Shoppers',
    'Actual value': 'Steve_Madden',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - The Company Store Shoppers',
    'Actual value': 'The_Company_Store',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Vitamins & Supplements - Bodybuilding.com Customers',
    'Actual value': 'Bodybuildingcom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Restaurant and Dining - Fine Dining - Del Frisco's Customers",
    'Actual value': 'Del_Friscos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Eyewear & Sunglasses - Eyeglass World Shoppers',
    'Actual value': 'Eyeglass_World',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - SIXT Customers',
    'Actual value': 'SIXT',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Taco Cabana Customers',
    'Actual value': 'Taco_Cabana',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Banking & Brokerage Services - Bank Of America Customers',
    'Actual value': 'Bank_Of_America',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Smartstyle Shoppers',
    'Actual value': 'Smartstyle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Waitr Customers',
    'Actual value': 'Waitr',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Ray-Ban Shoppers',
    'Actual value': 'Ray-Ban',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Christian Dior Shoppers',
    'Actual value': 'Christian_Dior',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Charitable and Social Services - Habitat For Humanity Donors',
    'Actual value': 'Habitat_For_Humanity',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Tickets Marketplace - WWE Network Customers',
    'Actual value': 'WWE_Network',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Dating Services - Tinder Customers',
    'Actual value': 'Tinder',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Educational Services - Kaplan Customers',
    'Actual value': 'Kaplan',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Pollo Tropical Customers',
    'Actual value': 'Pollo_Tropical',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - TaylorMade Golf Shoppers',
    'Actual value': 'TaylorMade_Golf',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Ice Cream Shops - Baskin-Robbins Shoppers',
    'Actual value': 'Baskin-Robbins',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Hugo Boss Shoppers',
    'Actual value': 'Hugo_Boss',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Destination Xl Shoppers",
    'Actual value': 'Destination_Xl',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Casual Restaurants - Pret A Manger Customers',
    'Actual value': 'Pret_A_Manger',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Bonobos Shoppers",
    'Actual value': 'Bonobos',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Vitamins & Supplements - Herbalife Shoppers',
    'Actual value': 'Herbalife',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Oakley Shoppers',
    'Actual value': 'Oakley',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - VF Sports Shoppers',
    'Actual value': 'VF_Sports',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Duty Free Shops - Dufry Shoppers',
    'Actual value': 'Dufry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Tire Warehouse Shoppers',
    'Actual value': 'Tire_Warehouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Timberland Shoppers',
    'Actual value': 'Timberland',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - The Golf Warehouse Shoppers',
    'Actual value': 'The_Golf_Warehouse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Health & Fitness - New York Sports Club Members',
    'Actual value': 'New_York_Sports_Club',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Cinnabon Customers',
    'Actual value': 'Cinnabon',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Casual Male Xl Shoppers",
    'Actual value': 'Casual_Male_Xl',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Childcare Services - Care.com Customers',
    'Actual value': 'Carecom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Field And Stream Shoppers',
    'Actual value': 'Field_And_Stream',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Home - Home Advising Services - Angie's List Customers",
    'Actual value': 'Angies_List',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Insurance Providers - Aetna Customers',
    'Actual value': 'Aetna',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Eastbay Shoppers',
    'Actual value': 'Eastbay',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Business Services - Transunion Customers',
    'Actual value': 'Transunion',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Entertainment - Tickets Marketplace - Live Nation Entertainment Customers',
    'Actual value': 'Live_Nation_Entertainment',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Computers & Electronics - Garmin Customers',
    'Actual value': 'Garmin',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Business Services - Experian Customers',
    'Actual value': 'Experian',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Jimmy Choo Shoppers',
    'Actual value': 'Jimmy_Choo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Club Monaco Shoppers',
    'Actual value': 'Club_Monaco',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Regis Salons Shoppers',
    'Actual value': 'Regis_Salons',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Tickets Marketplace - Atom Tickets Customers',
    'Actual value': 'Atom_Tickets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Service & Repair - CAR-X Tire & Auto Shoppers',
    'Actual value': 'CAR-X_Tire__and__Auto',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Farm Fresh Supermarkets Shoppers',
    'Actual value': 'Farm_Fresh_Supermarkets',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Manhattan Shoppers',
    'Actual value': 'Manhattan',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Eagle Gas Shoppers',
    'Actual value': 'Eagle_Gas',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Parts Retailers - Autopart International Shoppers',
    'Actual value': 'Autopart_International',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Underground Clothing Shoppers',
    'Actual value': 'Underground_Clothing',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Dickies Shoppers',
    'Actual value': 'Dickies',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Charitable and Social Services - American Red Cross Donors',
    'Actual value': 'American_Red_Cross',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Barkbox Subscribers',
    'Actual value': 'Barkbox_Subscribers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - HomeSense Shoppers',
    'Actual value': 'HomeSense',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Business Services - Equifax Customers',
    'Actual value': 'Equifax',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Mattress Stores - Tempur-Pedic Shoppers',
    'Actual value': 'Tempur-Pedic',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Mastercuts Shoppers',
    'Actual value': 'Mastercuts',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Educational Services - The Princeton Review Customers',
    'Actual value': 'The_Princeton_Review',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Sierra Trading Post Shoppers',
    'Actual value': 'Sierra_Trading_Post',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - Perfumania Shoppers',
    'Actual value': 'Perfumania',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Duty Free Shops - DFS Shoppers',
    'Actual value': 'DFS',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Boston Proper Shoppers',
    'Actual value': 'Boston_Proper',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Gas & Service Stations - Rebel Oil Shoppers',
    'Actual value': 'Rebel_Oil',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Allen Edmonds Shoppers',
    'Actual value': 'Allen_Edmonds',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Tax Wise Customers',
    'Actual value': 'Tax_Wise',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Goods Stores - Fabric.com Shoppers',
    'Actual value': 'Fabriccom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Mattress Stores - Casper Shoppers',
    'Actual value': 'Casper',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Foods Co. Shoppers',
    'Actual value': 'Foods_Co',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Software Services - Rosetta Stone Customers',
    'Actual value': 'Rosetta_Stone',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Puma Shoppers',
    'Actual value': 'Puma',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Children's Clothing & Toys - Build-A-Bear Workshop Shoppers",
    'Actual value': 'Build-A-Bear_Workshop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Restaurant and Dining - Fast Food & QSR - Jamba Juice Customers',
    'Actual value': 'Jamba_Juice',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Burlington Shoe Shoppers',
    'Actual value': 'Burlington_Shoe',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Converse Shoppers',
    'Actual value': 'Converse',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Balenciaga Shoppers',
    'Actual value': 'Balenciaga',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Casual Restaurants - Planet Hollywood International Customers',
    'Actual value': 'Planet_Hollywood_International',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Office, Electronics, Games - Online Gaming - Hoosier Park Racing & Casino Customers',
    'Actual value': 'Hoosier_Park_Racing__and__Casino',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Medical Services - Fastmed Customers',
    'Actual value': 'Fastmed',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - AC Lens Customers',
    'Actual value': 'AC_Lens',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Tax Slayer Customers',
    'Actual value': 'Tax_Slayer',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Food & Pharmacy - Food Delivery Services - Wolferman's Customers",
    'Actual value': 'Wolfermans',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - CJ Banks Shoppers',
    'Actual value': 'CJ_Banks',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - GameFly Shoppers',
    'Actual value': 'GameFly',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Palais Royal Customers',
    'Actual value': 'Palais_Royal',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Theory Shoppers',
    'Actual value': 'Theory',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Luxury Fashion Stores - Christopher Kane Shoppers',
    'Actual value': 'Christopher_Kane',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Eyewear & Sunglasses - Vista Optical Shoppers',
    'Actual value': 'Vista_Optical',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Automotive - Auto Tire Stores - Free Service Tire Company Shoppers',
    'Actual value': 'Free_Service_Tire_Company',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Men's Clothing & Accessories - Perry Ellis Shoppers",
    'Actual value': 'Perry_Ellis',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Children's Clothing & Toys - Hasbro Shoppers",
    'Actual value': 'Hasbro',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Twitch TV Customers',
    'Actual value': 'Twitch_TV',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - News & Magazines - Newsday Subscribers',
    'Actual value': 'Newsday',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Tax Tools & Services - Jackson Hewitt Customers',
    'Actual value': 'Jackson_Hewitt',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - The Pantry Shoppers',
    'Actual value': 'The_Pantry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Dating Services - Okcupid Customers',
    'Actual value': 'Okcupid',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Automotive - Auto Service & Repair - Monro Auto Service and Tire Centers Shoppers',
    'Actual value': 'Monro_Auto_Service_and_Tire_Centers',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Marc Jacobs Shoppers",
    'Actual value': 'Marc_Jacobs',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Entertainment - Tickets Marketplace - World Wrestling Entertainment Customers',
    'Actual value': 'World_Wrestling_Entertainment',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Birchbox Subscribers',
    'Actual value': 'Birchbox',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Improvement Stores - Benjamin Moore Shoppers',
    'Actual value': 'Benjamin_Moore',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Stock Yards Customers',
    'Actual value': 'Stock_Yards',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - Riot Games Shoppers',
    'Actual value': 'Riot_Games',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - JackRabbit Shoppers',
    'Actual value': 'JackRabbit',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Sportsmart Shoppers',
    'Actual value': 'Sportsmart',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Fashion Accessories - James Allen Shoppers',
    'Actual value': 'James_Allen',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Super Fresh Shoppers',
    'Actual value': 'Super_Fresh',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - Smartwool Shoppers',
    'Actual value': 'Smartwool',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Splendid Shoppers",
    'Actual value': 'Splendid',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Reebok Shoppers',
    'Actual value': 'Reebok',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - BeautyBar.com Customers',
    'Actual value': 'BeautyBarcom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Sam Edelman Shoppers',
    'Actual value': 'Sam_Edelman',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Footwear Retailers - Dolce Vita Shoes Shoppers',
    'Actual value': 'Dolce_Vita_Shoes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Sporting Goods & Outdoors - MyFitnessPal Shoppers',
    'Actual value': 'MyFitnessPal',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Software Services - Evite Customers',
    'Actual value': 'Evite',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Apparel & Accessories - Women's Clothing & Dresses - Topshop Shoppers",
    'Actual value': 'Topshop',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Footwear Retailers - Country Outfitter Customers',
    'Actual value': 'Country_Outfitter',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Stores - Burberry Shoppers',
    'Actual value': 'Burberry',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Apparel & Accessories - Footwear Retailers - Dr. Scholl's Shoes Shoppers",
    'Actual value': 'Dr_Scholls_Shoes',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Alternative Apparel Shoppers',
    'Actual value': 'Alternative_Apparel',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Eyewear & Sunglasses - Solstice Sunglasses Shoppers',
    'Actual value': 'Solstice_Sunglasses',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Duty Free Shops - World Duty Free Shoppers',
    'Actual value': 'World_Duty_Free',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Trunk Club Subscribers',
    'Actual value': 'Trunk_Club',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Childcare Services - Champion Customers',
    'Actual value': 'Champion',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Boston Store Shoppers',
    'Actual value': 'Boston_Store',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Mattress Stores - Select Comfort Shoppers',
    'Actual value': 'Select_Comfort',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Streaming Music & Video - Vimeo Subscribers',
    'Actual value': 'Vimeo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - Zynga Customers',
    'Actual value': 'Zynga',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Hawaiian Airlines Customers',
    'Actual value': 'Hawaiian_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Domestic Airlines - Allegiant Air Customers',
    'Actual value': 'Allegiant_Air',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - International Airlines - Qatar Airways Customers',
    'Actual value': 'Qatar_Airways',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - International Airlines - Turkish Airlines Customers',
    'Actual value': 'Turkish_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - International Airlines - Aeromexico Customers',
    'Actual value': 'Aeromexico',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - International Airlines - Lufthansa Customers',
    'Actual value': 'Lufthansa',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - International Airlines - Emirates Airlines Customers',
    'Actual value': 'Emirates_Airlines',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Booking.com Customers',
    'Actual value': 'Bookingcom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Hotwire.com Customers',
    'Actual value': 'Hotwirecom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - Agoda.com Customers',
    'Actual value': 'Agodacom',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Online Travel Agency - TripAdvisor Customers',
    'Actual value': 'TripAdvisor',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Princess Cruise Customers',
    'Actual value': 'Princess_Cruise',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Celebrity Cruises Customers',
    'Actual value': 'Celebrity_Cruises',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Cruise Lines - Holland America Line Customers',
    'Actual value': 'Holland_America_Line',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Busch Gardens Visitors',
    'Actual value': 'Busch_Gardens_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Cedar Point Visitors',
    'Actual value': 'Cedar_Point_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': "Entertainment - Amusement Parks - Knott's Berry Farm Visitors",
    'Actual value': 'Knotts_Berry_Farm_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Kings Dominion Visitors',
    'Actual value': 'Kings_Dominion_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Entertainment - Amusement Parks - Discovery Cove Visitors',
    'Actual value': 'Discovery_Cove_Visitors',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Thrifty Car Rental Customers',
    'Actual value': 'Thrifty_Car_Rental',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Dollar Rent A Car Customers',
    'Actual value': 'Dollar_Rent_A_Car',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - National Car Rental Customers',
    'Actual value': 'National_Car_Rental',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Travel - Car Rentals - Zipcar Customers',
    'Actual value': 'Zipcar',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Home - Home Furnishing & Decor Stores - MUJI Shoppers',
    'Actual value': 'MUJI',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Public Goods Customers',
    'Actual value': 'Public_Goods',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Print & Photography Services - Lifetouch Customers',
    'Actual value': 'Lifetouch',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Print & Photography Services - Zazzle Customers',
    'Actual value': 'Zazzle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Print & Photography Services - Walgreens Photo Customers',
    'Actual value': 'Walgreens_Photo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Print & Photography Services - Mpix Customers',
    'Actual value': 'Mpix',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Consumer Services - Print & Photography Services - Costco Photo Customers',
    'Actual value': 'Costco_Photo',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Print & Photography Services - Minted Customers',
    'Actual value': 'Minted',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Pet Owners - Nationwide Pet Insurance Customers',
    'Actual value': 'Nationwide_Pet_Insurance',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Consumer Services - Print & Photography Services - Snapfish Customers',
    'Actual value': 'Snapfish',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Yankee Candle Customers',
    'Actual value': 'Yankee_Candle',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Specialty Retail - Beauty Cosmetics Stores - Lush Shoppers',
    'Actual value': 'Lush',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Allbirds Shoppers',
    'Actual value': 'Allbirds',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      'Restaurant and Dining - Fast Food & QSR - Freebirds World Burrito Shoppers',
    'Actual value': 'Freebirds_World_Burrito',
  },
  {
    'Filter L1': 'AFS Brands',
    'Filter Display value':
      "Restaurant and Dining - Casual Restaurants - Gus's World Famous Fried Chicken Shoppers",
    'Actual value': 'Guss_World_Famous_Fried_Chicken',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Activewear',
    'Actual value': 'Activewear',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Alcohol Delivery Services',
    'Actual value': 'Alcohol_Delivery_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Amusement Parks',
    'Actual value': 'Amusement_Parks',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Apparel & Accessories',
    'Actual value': 'Apparel__and__Accessories',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Arts & Craft Stores',
    'Actual value': 'Arts__and__Craft_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Auto Parts Retailers',
    'Actual value': 'Auto_Parts_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Auto Service & Repair',
    'Actual value': 'Auto_Service__and__Repair',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Auto Tire Stores',
    'Actual value': 'Auto_Tire_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Automotive',
    'Actual value': 'Automotive',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Banking & Brokerage Services',
    'Actual value': 'Banking__and__Brokerage_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Beauty Cosmetics Stores',
    'Actual value': 'Beauty_Cosmetics_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Big Box Stores',
    'Actual value': 'Big_Box_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Business Services',
    'Actual value': 'Business_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Cable, Satellite & TV',
    'Actual value': 'Cable_Satellite__and__TV',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Car Rentals',
    'Actual value': 'Car_Rentals',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Casual Restaurants',
    'Actual value': 'Casual_Restaurants',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Charitable and Social Services',
    'Actual value': 'Charitable_and_Social_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Childcare Services',
    'Actual value': 'Childcare_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': "Children's Clothing & Toys",
    'Actual value': 'Childrens_Clothing__and__Toys',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Clothing & Fashion Retailers',
    'Actual value': 'Clothing__and__Fashion_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Computers & Electronics',
    'Actual value': 'Computers__and__Electronics',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Consumer Services',
    'Actual value': 'Consumer_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Convenience Stores',
    'Actual value': 'Convenience_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Cruise Lines',
    'Actual value': 'Cruise_Lines',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Dating Services',
    'Actual value': 'Dating_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Dental Products & Services',
    'Actual value': 'Dental_Products__and__Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Department Stores',
    'Actual value': 'Department_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Discount Clothing Stores',
    'Actual value': 'Discount_Clothing_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Discount Variety Stores',
    'Actual value': 'Discount_Variety_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Domestic Airlines',
    'Actual value': 'Domestic_Airlines',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Drug Stores & Pharmacy',
    'Actual value': 'Drug_Stores__and__Pharmacy',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Duty Free Shops',
    'Actual value': 'Duty_Free_Shops',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Economy Hotels',
    'Actual value': 'Economy_Hotels',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Educational Services',
    'Actual value': 'Educational_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Entertainment',
    'Actual value': 'Entertainment',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Eyewear & Sunglasses',
    'Actual value': 'Eyewear__and__Sunglasses',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Fashion Accessories',
    'Actual value': 'Fashion_Accessories',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Fast Food & QSR',
    'Actual value': 'Fast_Food__and__QSR',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Fine Dining',
    'Actual value': 'Fine_Dining',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Food & Pharmacy',
    'Actual value': 'Food__and__Pharmacy',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Food Delivery Services',
    'Actual value': 'Food_Delivery_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Footwear Retailers',
    'Actual value': 'Footwear_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Gas & Service Stations',
    'Actual value': 'Gas__and__Service_Stations',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Gifts & Party Retailers',
    'Actual value': 'Gifts__and__Party_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Grocery Delivery Services',
    'Actual value': 'Grocery_Delivery_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Grocery Stores',
    'Actual value': 'Grocery_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Health & Fitness',
    'Actual value': 'Health__and__Fitness',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Home',
    'Actual value': 'Home',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Home Advising Services',
    'Actual value': 'Home_Advising_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Home Furnishing & Decor Stores',
    'Actual value': 'Home_Furnishing__and__Decor_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Home Goods Stores',
    'Actual value': 'Home_Goods_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Home Improvement Stores',
    'Actual value': 'Home_Improvement_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Ice Cream Shops',
    'Actual value': 'Ice_Cream_Shops',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Insurance Providers',
    'Actual value': 'Insurance_Providers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'International Airlines',
    'Actual value': 'International_Airlines',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Investment Institutions',
    'Actual value': 'Investment_Institutions',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Jewelry Stores',
    'Actual value': 'Jewelry_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Luxury Fashion Stores',
    'Actual value': 'Luxury_Fashion_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Luxury Hotels',
    'Actual value': 'Luxury_Hotels',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Mass Retailers',
    'Actual value': 'Mass_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Mattress Stores',
    'Actual value': 'Mattress_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Meal Kit Services',
    'Actual value': 'Meal_Kit_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Medical Services',
    'Actual value': 'Medical_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': "Men's Clothing & Accessories",
    'Actual value': 'Mens_Clothing__and__Accessories',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': "Men's Grooming",
    'Actual value': 'Mens_Grooming',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Mid-tier Hotels',
    'Actual value': 'Mid-tier_Hotels',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Movies & Films',
    'Actual value': 'Movies__and__Films',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Moving & Storage Services',
    'Actual value': 'Moving__and__Storage_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'News & Magazines',
    'Actual value': 'News__and__Magazines',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Office Supply Stores',
    'Actual value': 'Office_Supply_Stores',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Office, Electronics, Games',
    'Actual value': 'Office_Electronics_Games',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Online & Mobile Retailers',
    'Actual value': 'Online__and__Mobile_Retailers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Online Flower Delivery',
    'Actual value': 'Online_Flower_Delivery',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Online Gaming',
    'Actual value': 'Online_Gaming',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Online Shoppers',
    'Actual value': 'Online_Shoppers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Online Travel Agency',
    'Actual value': 'Online_Travel_Agency',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Pet Owners',
    'Actual value': 'Pet_Owners',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Photography Services',
    'Actual value': 'Photography_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Restaurant and Dining',
    'Actual value': 'Restaurant_and_Dining',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Retail Warehouse Clubs',
    'Actual value': 'Retail_Warehouse_Clubs',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Shipping & Tracking',
    'Actual value': 'Shipping__and__Tracking',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Software Services',
    'Actual value': 'Software_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Specialty Retail',
    'Actual value': 'Specialty_Retail',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Sporting Goods & Outdoors',
    'Actual value': 'Sporting_Goods__and__Outdoors',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Streaming Music & Video',
    'Actual value': 'Streaming_Music__and__Video',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Subscription Shoppers',
    'Actual value': 'Subscription_Shoppers',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Tax Tools & Services',
    'Actual value': 'Tax_Tools__and__Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Tickets Marketplace',
    'Actual value': 'Tickets_Marketplace',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Travel',
    'Actual value': 'Travel',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Vitamins & Supplements',
    'Actual value': 'Vitamins__and__Supplements',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Weight Loss Services',
    'Actual value': 'Weight_Loss_Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': 'Wireless Products & Services',
    'Actual value': 'Wireless_Products__and__Services',
  },
  {
    'Filter L1': 'AFS Categories',
    'Filter Display value': "Women's Clothing & Dresses",
    'Actual value': 'Womens_Clothing__and__Dresses',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Burger Lovers',
    'Actual value': 'Burger_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Chicken Lovers',
    'Actual value': 'Chicken_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Donut Lovers',
    'Actual value': 'Donut_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Ice Cream Lovers',
    'Actual value': 'Ice_Cream_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Deli Lovers',
    'Actual value': 'Deli_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Asian Food Lovers',
    'Actual value': 'Asian_Food_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Health Food Lovers',
    'Actual value': 'Health_Food_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Italian Food Lovers',
    'Actual value': 'Italian_Food_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Seafood Lovers',
    'Actual value': 'Seafood_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Gaming & Gambling - Online Gambling Lovers',
    'Actual value': 'Online_Gambling_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Steak Lovers',
    'Actual value': 'Steak_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Wings Lovers',
    'Actual value': 'Wings_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Bagel Lovers',
    'Actual value': 'Bagel_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Automotive - Luxury Car Lovers',
    'Actual value': 'Luxury_Car_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Automotive - Foreign Car Lovers',
    'Actual value': 'Foreign_Car_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Relationship Seekers',
    'Actual value': 'Relationship_Seekers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Health & Fitness - Contact Lens Lovers',
    'Actual value': 'Contact_Lens_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Mexican Food Lovers',
    'Actual value': 'Mexican_Food_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Pizza Lovers',
    'Actual value': 'Pizza_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Sandwich Lovers',
    'Actual value': 'Sandwich_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Baby Product Lovers',
    'Actual value': 'Baby_Product_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sporting Goods & Outdoors - Golfers',
    'Actual value': 'Golfers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Gaming & Gambling - Gamers',
    'Actual value': 'Gamers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Health & Fitness - Oral Care Product Lovers',
    'Actual value': 'Oral_Care_Product_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Coffee Lovers',
    'Actual value': 'Coffee_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Razor Lovers',
    'Actual value': 'Razor_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Health & Fitness - Weight Loss Lovers',
    'Actual value': 'Weight_Loss_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Health & Fitness - Sneaker Lovers',
    'Actual value': 'Sneaker_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Travel - Cruise Lovers',
    'Actual value': 'Cruise_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Travel - Luxury Vacation Lovers',
    'Actual value': 'Luxury_Vacation_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Sunglass Lovers',
    'Actual value': 'Sunglass_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Liquor Lovers',
    'Actual value': 'Liquor_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - Sports Fans',
    'Actual value': 'Sports_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Automotive - Domestic Car Lovers',
    'Actual value': 'Domestic_Car_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Smoothie Lovers',
    'Actual value': 'Smoothie_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Wine Lovers',
    'Actual value': 'Wine_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Dog Owners',
    'Actual value': 'Dog_Owners',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sporting Goods & Outdoors - Skiers',
    'Actual value': 'Skiers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Gaming & Gambling - Casino Lovers',
    'Actual value': 'Casino_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sporting Goods & Outdoors - Outdoor Enthusiast',
    'Actual value': 'Outdoor_Enthusiast',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Food Lovers - Pretzel Lovers',
    'Actual value': 'Pretzel_Lovers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - NHL Fans',
    'Actual value': 'NHL_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - NBA Fans',
    'Actual value': 'NBA_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - MLB Fans',
    'Actual value': 'MLB_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - NFL Fans',
    'Actual value': 'NFL_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Sports Enthusiast - NASCAR Fans',
    'Actual value': 'NASCAR_Fans',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Travel - Business Travelers',
    'Actual value': 'Business_Travelers',
  },
  {
    'Filter L1': 'AFS Lifestyle',
    'Filter Display value': 'Consumer Services - Recent Movers',
    'Actual value': 'Recent_Movers',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Aaron Brothers Shoppers',
    'Actual value': 'Aaron_Brothers_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Gap Inc. Shoppers',
    'Actual value': 'Gap_Inc_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Apparel & Accessories - Sporting Goods & Activewear - Golf Galaxy Shoppers',
    'Actual value': 'Golf_Galaxy_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Home - Home Goods & Furnishing - HomeGoods Shoppers',
    'Actual value': 'HomeGoods_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Apparel & Accessories - Sporting Goods & Activewear - REI Shoppers',
    'Actual value': 'REI_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Shopko Shoppers',
    'Actual value': 'Shopko_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Specialty Retail - Gifts & Party Retailers - Barnes & Noble Shoppers',
    'Actual value': 'Barnes__and__Noble_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      "Apparel & Accessories - Sporting Goods & Activewear - Dick's Sporting Goods Shoppers",
    'Actual value': 'Dicks_Sporting_Goods_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Specialty Retail - Arts & Craft Stores - A.C. Moore Shoppers',
    'Actual value': 'AC_Moore_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Apparel & Accessories - Footwear Retailers - Payless Shoppers',
    'Actual value': 'Payless_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      "Apparel & Accessories - Sporting Goods & Activewear - Modell's Sporting Goods Shoppers",
    'Actual value': 'Modells_Sporting_Goods_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Apparel & Accessories - Department Stores - Nordstrom Shoppers',
    'Actual value': 'Nordstrom_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - Movies & Films - Fandango Customers',
    'Actual value': 'Fandango_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': "Restaurant and Dining - Fast Food Restaurants - Arby's Customers",
    'Actual value': 'Arbys_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      "Apparel & Accessories - Women's Clothing & Dresses - Dress Barn Shoppers",
    'Actual value': 'Dress_Barn_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Office, Electronics, Games - Video/PC Game Stores - Big Fish Games Shoppers',
    'Actual value': 'Big_Fish_Games_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Apparel & Accessories - Sporting Goods & Activewear - Bass Pro Shops Shoppers',
    'Actual value': 'Bass_Pro_Shops_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Drugstores & Pharmacy',
    'Actual value': 'Drugstores__and__Pharmacy_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Home - Home Furnishing',
    'Actual value': 'Home_Furnishing_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Movies & Films',
    'Actual value': 'Movies__and__Films_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Travel - Domestic & International Airlines',
    'Actual value': 'Domestic__and__International_Airlines_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - Sling TV Customers',
    'Actual value': 'Sling_TV_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Restaurant and Dining - Fast Food Restaurants - Au Bon Pain Customers',
    'Actual value': 'Au_Bon_Pain_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - Tickets Marketplace - Ticketfly Customers',
    'Actual value': 'Ticketfly_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Food & Pharmacy - Drugstores & Pharmacy - Haggen Food & Pharmacy Shoppers',
    'Actual value': 'Haggen_Food__and__Pharmacy_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Cable, Satellite & TV - Metro PCS Customers',
    'Actual value': 'Metro_PCS_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Apparel & Accessories - Sporting Goods & Activewear - Gander Outdoors Shoppers',
    'Actual value': 'Gander_Outdoors_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Subscription Shoppers',
    'Actual value': 'Subscription_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - Movies & Films - Moviepass Customers',
    'Actual value': 'Moviepass_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Disney+',
    'Actual value': 'Disney+_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Shell Shoppers',
    'Actual value': 'Shell_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - Drizly Customers',
    'Actual value': 'Drizly_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Food Delivery Services - ReserveBar Customers',
    'Actual value': 'ReserveBar_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - CBS All Access Subscribers',
    'Actual value': 'CBS_All_Access_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - HBO Subscribers',
    'Actual value': 'HBO_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - Youtube TV Subscribers',
    'Actual value': 'Youtube_TV_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Entertainment - Fubo TV Subscribers',
    'Actual value': 'Fubo_TV_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Health & Fitness - Peloton Customers',
    'Actual value': 'Peloton_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Health & Fitness - SoulCycle Customers',
    'Actual value': 'SoulCycle_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Apparel & Accessories - Luxury Fashion Accessories - Harveys Shoppers',
    'Actual value': 'Harveys_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Grocery Stores - Stein Mart Shoppers',
    'Actual value': 'Stein_Mart_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Photography Services - Lifetouch Customers',
    'Actual value': 'Lifetouch_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Wireless Products & Services - Vonage Customers',
    'Actual value': 'Vonage_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Convenience Stores - The Pantry Shoppers',
    'Actual value': 'The_Pantry_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Consumer Services - Photography Services - Artifact Uprising Customers',
    'Actual value': 'Artifact_Uprising_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Photography Services - Blurb Customers',
    'Actual value': 'Blurb_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Photography Services - Google Photos Customers',
    'Actual value': 'Google_Photos_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Photography Services - Mixbook Customers',
    'Actual value': 'Mixbook_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'NASCAR',
    'Actual value': 'NASCAR_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Nationwide Pet Insurance Customers',
    'Actual value': 'Nationwide_Pet_Insurance_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Crypto Currency Services - Binance Customers',
    'Actual value': 'Binance_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Venmo Customers',
    'Actual value': 'Venmo_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Healthcare Clothing & Accessories - Scrubs & Beyond Customers',
    'Actual value': 'Scrubs__and__Beyond_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - PayPal Customers',
    'Actual value': 'PayPal_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Healthcare Clothing & Accessories',
    'Actual value': 'Healthcare_Clothing__and__Accessories_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Crypto Currency Services - Coinbase Customers',
    'Actual value': 'Coinbase_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Crypto Currency Services - Crypto.com Customers',
    'Actual value': 'Cryptocom_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Allheart Customers',
    'Actual value': 'Allheart_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Uniform Advantage Customers',
    'Actual value': 'Uniform_Advantage_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Photography Service Customers',
    'Actual value': 'Photography_Service_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Crypto Currency Services',
    'Actual value': 'Crypto_Currency_Services_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Political Donors - Democratic Donors',
    'Actual value': 'Democratic_Donors_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Political Donors',
    'Actual value': 'Political_Donors_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Political Donors - Republican Donors',
    'Actual value': 'Republican_Donors_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Political Donors - Independent Donors',
    'Actual value': 'Independent_Donors_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Tonal Customers',
    'Actual value': 'Tonal_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Office, Electronics, Games - Online Gaming - Nintendo Shoppers',
    'Actual value': 'Nintendo_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Simple Mobile Customers',
    'Actual value': 'Simple_Mobile_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Mint Mobile Customers',
    'Actual value': 'Mint_Mobile_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': '23andMe Customers',
    'Actual value': '23andMe_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Ancestry.com Customers',
    'Actual value': 'Ancestrycom_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'The Mirror Customers',
    'Actual value': 'The_Mirror_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Apparel & Accessories - Clothing & Fashion Retailers - Columbia Sportswear Shoppers',
    'Actual value': 'Columbia_Sportswear_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Straight Talk Wireless Customers',
    'Actual value': 'Straight_Talk_Wireless_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'TextNow Customers',
    'Actual value': 'TextNow_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Specialty Retail - Guitar Center Customers',
    'Actual value': 'Guitar_Center_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'WordPress Customers',
    'Actual value': 'WordPress_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Software Services - Squarespace Customers',
    'Actual value': 'Squarespace_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Gas Stations & Convenient Stores',
    'Actual value': 'Gas_Stations__and__Convenient_Stores_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Food & Pharmacy - Grocery Store Shoppers',
    'Actual value': 'Grocery_Store_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Home Essentials Shoppers',
    'Actual value': 'Home_Essentials_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Office, Electronics, Games - Video/PC Game Stores',
    'Actual value': 'Video/PC_Game_Stores_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Pet Owners',
    'Actual value': 'Pet_Owners_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Consumer Services - Software Services - GoDaddy Customers',
    'Actual value': 'GoDaddy_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Alo Yoga Shoppers',
    'Actual value': 'Alo_Yoga_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'Vuori Customers',
    'Actual value': 'Vuori_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value': 'New York Life Insurance Customers',
    'Actual value': 'New_York_Life_Insurance_liveramp',
  },
  {
    'Filter L1': 'AFS LiveRamp',
    'Filter Display value':
      'Specialty Retail - Sporting Goods & Outdoors - Golf Club & Equipment Shoppers',
    'Actual value': 'Golf_Club__and__Equipment_liveramp',
  },
]
